<template>
  <div class="jia-re-page">

    <div class="bbb">


      <div class="top-action-bar">
        <el-radio-group v-model="radio3" size="small" class="page-tabs" @input="change">
          <el-radio-button label="1">视频号视频</el-radio-button>
          <el-radio-button label="2">平台订单信息</el-radio-button>
        </el-radio-group>

        <div class="top-action-actions">
          <el-tag v-if="groupData.length" size="small" type="info" effect="plain">待下单 {{ groupData.length }} 组</el-tag>
          <el-button
              type="success"
              size="small"
              plain
              icon="el-icon-coin"
              class="cps-gold-entry"
              @click="openCpsGoldDrawer">
            CPS加热余额
          </el-button>
          <el-button
              type="primary"
              size="small"
              plain
              icon="el-icon-s-promotion"
              class="submit-all-button"
              :disabled="!groupData.length"
              @click="submitAll()">
            全部下单
          </el-button>
        </div>
      </div>

      <div v-for="(ob,index) in groupData" :key="ob">


        <el-card class="box-card" shadow="hover">
          <span style="font-size: 13px;font-weight: bold;color: #3a8ee6">{{ '第' + index + '单' }}</span>

          <el-button type="danger" @click="delGroup2(index)" size="mini">删除该订单</el-button>

          <el-row :gutter="20">

            <el-col :span="1.5" v-for="(o,index2) in ob" :key="o" class="text item" style="border: outset">
              <el-row>
                <img :src="o.coverUrl" class="image" alt="" style="width: 100px;"></el-row>
              <el-row><span style="font-size: 13px">{{ ':共加热:' + o.hotSize + '次' }}</span></el-row>
              <el-row><span style="font-size: 13px;color: #3a8ee6" @click="delGroup(index,index2)">删除</span></el-row>
            </el-col>

            <el-col>

            </el-col>
          </el-row>
        </el-card>
      </div>

      <div v-show="this.radio3!=='3'">

        <div class="order-config-panel" :class="{'is-collapsed': orderConfigCollapsed}">
          <div class="order-config-header">
            <div class="order-config-heading">
              <div class="order-config-title-row">
                <div class="order-config-title">创建订单</div>
                <el-tag size="mini" type="info" effect="plain">{{ orderConfigCollapsed ? '已收起' : '已展开' }}</el-tag>
              </div>
              <div class="order-config-subtitle">{{ orderConfigCollapsed ? orderConfigSummary : '设置加热目标、定向条件和提交方式' }}</div>
            </div>
            <div class="order-config-actions">
              <el-button size="mini" type="text" :icon="orderConfigCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="toggleOrderConfigCollapsed">
                {{ orderConfigCollapsed ? '展开配置' : '收起配置' }}
              </el-button>
              <el-button type="danger" size="mini" icon="el-icon-s-promotion" @click="submit()"
                         v-show="this.radio3!=='3'">立即下单
              </el-button>
              <el-button type="primary" size="mini" icon="el-icon-collection-tag" @click="submitYu()"
                         v-show="this.radio3!=='3'">存为预制餐
              </el-button>
            </div>
          </div>

          <div v-show="!orderConfigCollapsed" class="order-config-body">
          <div class="config-section">
            <div class="config-section-title">基础设置</div>
            <div class="config-grid">
              <div class="config-field config-field-xl">
                <div class="config-label label-with-tip">
                  <span>优先提升目标</span>
                  <el-tooltip content="智能加热：把视频推送给能够带来更多自然流量溢出的人群；其他目标：把视频推送给更容易产生目标转化的人群。" placement="top" popper-class="config-help-popper">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-radio-group v-model="param.feedPromotionOrderInfo.promotionTarget" size="mini" class="radio-list">
                  <el-radio :label="3">组件点击</el-radio>
                  <el-radio :label="13">付费人数</el-radio>
                  <el-radio :label="21">付费ROI</el-radio>
                  <el-radio :label="16">虚拟支付</el-radio>
                  <el-radio :label="17">广告变现</el-radio>
                  <el-radio :label="advertRoiValue">{{ advertRoiText }}</el-radio>
                </el-radio-group>
              </div>

              <div class="config-field">
                <div class="config-label label-with-tip">
                  <span>归因周期</span>
                  <el-tooltip content="我们将按照你的选择，将用户从素材下发开始的固定周期内的转化行为归因到本加热订单。" placement="top" popper-class="config-help-popper">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-radio-group v-model="attributionPeriod" size="mini" @change="handleAttributionChange" :disabled="!isAttributionMetricSelected">
                  <el-radio label="1">首日</el-radio>
                  <el-radio label="7">7日</el-radio>
                </el-radio-group>
              </div>

              <div class="config-field">
                <div class="config-label label-with-tip">
                  <span>出价</span>
                  <el-tooltip content="微信豆出价最大支持2位小数精度；不同目标的单价范围以平台返回限制为准。" placement="top" popper-class="config-help-popper">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input-number v-model="price" controls-position="right"
                                 size="mini" :min="0" :max="999" :step="0.01"></el-input-number>
              </div>

              <div class="config-field">
                <div class="config-label label-with-tip">
                  <span>下单金额</span>
                  <el-tooltip content="实际效果与视频质量有关；若加热未完成，剩余流量券和微信豆将返还。下单金额范围以平台限制为准。" placement="top" popper-class="config-help-popper">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input-number v-model="param.feedPromotionOrderInfo.estimatedWecoinAmount" controls-position="right"
                                 size="mini" :min="1" :max="99999"></el-input-number>
              </div>

              <div class="config-field">
                <div class="config-label label-with-tip">
                  <span>扣费资金类型</span>
                  <el-tooltip content="订单或计划仅支持使用一种资金类型创建，不支持现金与微信豆混用。" placement="top" popper-class="config-help-popper">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-radio-group v-model="param.feedPromotionOrderInfo.billingMethod" size="mini">
                  <el-radio :label="0">现金</el-radio>
                  <el-radio :label="1">微信豆</el-radio>
                </el-radio-group>
              </div>

              <div class="config-field" v-if="isAttributionMetricSelected">
                <div class="config-label label-with-tip">
                  <span>广告变现ROI出价</span>
                  <el-tooltip content="ROI 出价最大支持4位小数精度；可填写范围以平台返回限制为准。" placement="top" popper-class="config-help-popper">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input-number v-model="param.feedPromotionOrderInfo.suggest.roiBid" controls-position="right" size="mini" :min="0" :max="999" :step="0.01"></el-input-number>
              </div>

              <div class="config-field">
                <div class="config-label label-with-tip">
                  <span>加热时长</span>
                  <el-tooltip content="平台要求选择有效的加热时长；当前可选 6小时、12小时、24小时。" placement="top" popper-class="config-help-popper">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-radio-group v-model="param.feedPromotionOrderInfo.duration" size="mini">
                  <el-radio label="86400">24小时</el-radio>
                  <el-radio label="43200">12小时</el-radio>
                  <el-radio label="21600">6小时</el-radio>
                </el-radio-group>
              </div>

              <div class="config-field">
                <div class="config-label label-with-tip">
                  <span>加热方式</span>
                  <el-tooltip content="智能加热会使用平台放量策略；定向加热会按下方人群条件投放。平台切换方案时可能重置部分定向条件。" placement="top" popper-class="config-help-popper">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-radio-group v-model="param.feedPromotionOrderInfo.promotionType" size="mini">
                  <el-radio :label="1">智能加热</el-radio>
                  <el-radio :label="2">定向加热</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>

          <div class="config-section">
            <div class="config-section-title">人群定向</div>
            <div class="config-grid">
              <div class="config-field">
                <div class="config-label label-with-tip">
                  <span>性别定向</span>
                  <el-tooltip content="未指定时按不限处理。" placement="top" popper-class="config-help-popper">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-checkbox-group v-model="param.feedPromotionOrderInfo.suggest.gender" size="mini" :max="1" class="checkbox-list">
                  <el-checkbox :label="0">不限</el-checkbox>
                  <el-checkbox :label="1">男</el-checkbox>
                  <el-checkbox :label="2">女</el-checkbox>
                </el-checkbox-group>
              </div>

              <div class="config-field">
                <div class="config-label label-with-tip">
                  <span>设备定向</span>
                  <el-tooltip content="未指定时按全部设备处理。" placement="top" popper-class="config-help-popper">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-radio-group v-model="param.feedPromotionOrderInfo.suggest.deviceTypes" size="mini">
                  <el-radio :label="0">不限</el-radio>
                  <el-radio :label="1">iOS</el-radio>
                  <el-radio :label="2">安卓</el-radio>
                </el-radio-group>
              </div>

              <div class="config-field">
                <div class="config-label">注册状态推荐</div>
                <el-checkbox-group v-model="param.feedPromotionOrderInfo.suggest.gameRegisters" size="mini" class="checkbox-list">
                  <el-checkbox :label="0">未注册</el-checkbox>
                  <el-checkbox :label="1">已流失</el-checkbox>
                  <el-checkbox :label="2">已注册</el-checkbox>
                </el-checkbox-group>
              </div>

              <div class="config-field config-field-wide">
                <div class="config-label label-with-tip">
                  <span>根据年龄推荐</span>
                  <el-tooltip content="未选择年龄段时，平台订单详情按全部展示。" placement="top" popper-class="config-help-popper">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-checkbox-group v-model="param.feedPromotionOrderInfo.suggest.ageRange" size="mini" class="checkbox-list">
                  <el-checkbox :label="1">18-24岁</el-checkbox>
                  <el-checkbox :label="2">25-29岁</el-checkbox>
                  <el-checkbox :label="3">30-39岁</el-checkbox>
                  <el-checkbox :label="4">40-49岁</el-checkbox>
                  <el-checkbox :label="5">50岁以上</el-checkbox>
                </el-checkbox-group>
              </div>

              <div class="config-field">
                <div class="config-label label-with-tip">
                  <span>搜索放宽定向</span>
                  <el-tooltip content="平台默认开启；开启后提交搜索放宽定向参数，关闭时会明确提交关闭。" placement="top" popper-class="config-help-popper">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-radio-group v-model="param.feedPromotionOrderInfo.suggest.enableSearchRelaxTargeting" size="mini">
                  <el-radio :label="true">开启</el-radio>
                  <el-radio :label="false">关闭</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>

          <div class="config-section config-section-last">
            <div class="config-section-title">提交设置</div>
            <div class="config-grid">
              <div class="config-field config-field-wide">
                <div class="config-label label-with-tip">
                  <span>定时加热</span>
                  <el-tooltip content="不选择时间时立即开始；选择定时加热时需在平台允许的时间范围内。" placement="top" popper-class="config-help-popper">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-date-picker
                    size="mini"
                    v-model="estimatedStartts"
                    align="right"
                    value-format="timestamp"
                    type="datetime"
                    class="start-time-picker"
                    placeholder="选择日期"
                >
                </el-date-picker>
              </div>

              <div class="config-field config-field-wide">
                <div class="config-label">分单</div>
                <div class="config-inline">
                  <el-radio-group v-model="isMore" size="mini">
                    <el-radio :label="0">是</el-radio>
                    <el-radio :label="1">否</el-radio>
                  </el-radio-group>
                  <span v-show="isMore===1" class="split-tip">每隔几单打包</span>
                  <el-input-number v-model="fNum" size="mini" class="split-number" v-show="isMore===1"></el-input-number>
                </div>
              </div>

              <div class="config-field">
                <div class="config-label">是否自动扫码</div>
                <el-radio-group v-model="flag" size="mini">
                  <el-radio label="0">否</el-radio>
                  <el-radio label="1">是</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
          </div>
        </div>

      </div>


      <span class="selected-summary">已选中:{{
          this.selectionArray.length
        }}/{{ this.dataT.length + this.tableData2.length }}</span>


      <div v-show="this.radio3==='3'" style="margin-top: 20px">
        <el-select
            v-model="zhanghao"
            filterable
            size="mini"
            allow-create
            clearable
            default-first-option
            @change="changeZH"
            placeholder="请输入加热账号">
          <el-option
              v-for="item in tableData"
              :key="item"
              :label="item.name"
              :value="item.name">

            <span style="float: left">{{ item.name }}</span>

            <span v-if="item.status===0"
                  style="margin-left:5px;float: right; color: #2bd374; font-size: 13px">在线</span>
            <span v-else style="margin-left:5px;float: right; color: #8492a6; font-size: 13px">离线</span>
            <span style="margin-left:5px;float: right; color: #7919c9; font-size: 13px">{{ item.accountBalance }}</span>
          </el-option>
        </el-select>

        <el-radio-group v-model="isStatus" size="mini">
          <el-radio label="0">未完成</el-radio>
          <el-radio label="1">已完成</el-radio>

        </el-radio-group>
        <el-button type="danger" size="mini" style="margin-left: 10px" @click="search4()">刷新</el-button>
        <el-button type="primary" size="mini" style="margin-left: 5px;margin-top: 15px" @click="submitYuO()"
                   v-show="this.radio3==='3'">提交预制订单
        </el-button>
        <el-table
            :data="tableDataYuZhi"
            border
            :header-cell-style="{background:'#f8f8f9',textAlign:'center',color:'#515A6E','padding':'5px'}"
            class="table-1"
            size="mini"
            stripe
            @select-all="select5"
            @select="select5"
            ref="tableData1"
            highlight-current-row
            height="77vh"
            v-loading="loading2"

        >

          <!--          <el-table-column-->
          <!--              prop="cDate"-->
          <!--              label="操作"-->
          <!--              align="center"-->
          <!--              width="200"-->
          <!--              fixed-->

          <!--          >-->

          <!--            <template slot-scope="scope">-->


          <!--              <el-button size="mini" type="primary" @click="dbclick(scope.row)">复制</el-button>-->
          <!--              <el-button size="mini" type="primary" @click="del(scope.row)">取消</el-button>-->

          <!--              <el-popover-->
          <!--                  placement="right"-->
          <!--                  width="400"-->
          <!--                  trigger="click">-->
          <!--                <vue-qr :callback="getCode" class="qr-code" :color-dark="randomColor" style="width: 450px"-->
          <!--                        :text="'https://channels.weixin.qq.com/promote/pages/mobile_pay?promotionId='+scope.row.orderInfo.promotionId+'&type=feed&userType=3&corproateId='+corId+'&exportkey=n_ChQIAhIQ069AoCSv824bRiBCnf5zIxLyAQIE97dBBAEAAAAAAGAFLG7PCcUAAAAOpnltbLcz9gKNyK89dVj046M5lOx3u%2FM1iPOL8EL%2FjPBumHYlTBqbGdlGJDqp67kk%2B6YOs7SC1lme8FeqkKWIp0F3%2BuN5e%2BmZmVdkvP64NSlk8q%2BBTWb8eZh4lLOF8n5TyOi9JtM3V%2Fsoj390bw3pm0p8Nhx6LmCVqIwRhPzURBD0Pq8TzGr9I59iZLEiSXl34OuugrB%2FVA%2BOsRfxoNFsnm9KkoxG6XMfQydVg0QyR32eoMOuW0SdJDzQxhchQTNprTn4wCpIf%2BDd7jfRJFw%2FXN5rasy%2BZ7H2qRA8&pass_ticket=mkYT1tSASyHrOO0N%2Bau7jqdSsw1cX0GaTE4YMQ2hHO0Uw81HMntYVHhm2IrTybm0kmG0BaxyqrkRLEgqtIGpBw%3D%3D&wx_header=0'">-->

          <!--                </vue-qr>-->
          <!--                <el-button slot="reference" style="margin-left: 3px" icon="el-icon-zoom-in" type="primary"-->
          <!--                           size="mini"></el-button>-->
          <!--              </el-popover>-->
          <!--              <vue-qr :callback="getCode" class="qr-code" :color-dark="randomColor"-->
          <!--                      :text="'https://channels.weixin.qq.com/promote/pages/mobile_pay?promotionId='+scope.row.orderInfo.promotionId+'&type=feed&userType=3&corproateId='+corId+'&exportkey=n_ChQIAhIQ069AoCSv824bRiBCnf5zIxLyAQIE97dBBAEAAAAAAGAFLG7PCcUAAAAOpnltbLcz9gKNyK89dVj046M5lOx3u%2FM1iPOL8EL%2FjPBumHYlTBqbGdlGJDqp67kk%2B6YOs7SC1lme8FeqkKWIp0F3%2BuN5e%2BmZmVdkvP64NSlk8q%2BBTWb8eZh4lLOF8n5TyOi9JtM3V%2Fsoj390bw3pm0p8Nhx6LmCVqIwRhPzURBD0Pq8TzGr9I59iZLEiSXl34OuugrB%2FVA%2BOsRfxoNFsnm9KkoxG6XMfQydVg0QyR32eoMOuW0SdJDzQxhchQTNprTn4wCpIf%2BDd7jfRJFw%2FXN5rasy%2BZ7H2qRA8&pass_ticket=mkYT1tSASyHrOO0N%2Bau7jqdSsw1cX0GaTE4YMQ2hHO0Uw81HMntYVHhm2IrTybm0kmG0BaxyqrkRLEgqtIGpBw%3D%3D&wx_header=0'">-->

          <!--              </vue-qr>-->

          <!--            </template>-->

          <!--          </el-table-column>-->

          <el-table-column
              type="selection"
              align="center"
              fixed
              width="60">
          </el-table-column>


          <el-table-column
              type="index"
              label="序列"
              align="center"
              width="78">
          </el-table-column>


          <el-table-column
              align="center"
              prop="zhangHao"
              label="加热账号"

          >

          </el-table-column>


          <el-table-column
              align="center"
              prop="orderCover"
              label="封面图"
              width="160"
          >
            <template scope="scope">

              <el-image :src="scope.row.orderCover" style="display:block"
                        :preview-src-list="[scope.row.orderCover]"></el-image>
            </template>

          </el-table-column>
          <el-table-column
              align="center"
              prop="orderData.sequence"
              label="出价"

          >
            <template scope="scope">

              <span>{{ JSON.parse(scope.row.orderData).feedPromotionOrderInfo.suggest.wecoinBid }}</span>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              prop="orderData.sequence"
              label="开启投放时间"
          >
            <template scope="scope">

              {{ JSON.parse(scope.row.orderData).estimatedStartts * 1000|dateFilter }}
            </template>
          </el-table-column>
        </el-table>

      </div>

      <div v-show="this.radio3==='1'">

        <el-select
            v-model="zhanghao"
            filterable
            size="mini"
            allow-create
            clearable
            default-first-option
            @change="changeZH"
            placeholder="请输入加热账号">
          <el-option
              v-for="item in tableData"
              :key="item"
              :label="item.name"
              :value="item.name">

            <span style="float: left">{{ item.name }}</span>

            <span v-if="item.status===0"
                  style="margin-left:5px;float: right; color: #2bd374; font-size: 13px">在线</span>
            <span v-else style="margin-left:5px;float: right; color: #8492a6; font-size: 13px">离线</span>
            <span style="margin-left:5px;float: right; color: #7919c9; font-size: 13px">{{ item.accountBalance }}</span>
          </el-option>
        </el-select>
        <el-input
            placeholder="请输入被加热账号"
            v-model="videoName"
            size="mini"
            style="width: 250px;margin-left: 10px"
            clearable>
        </el-input>
        <el-date-picker
            v-model="value1"
            style="margin-left: 14px;margin-top:6px"
            size="mini"
            type="daterange"
            range-separator="至"

            align="right"
            unlink-panels
            :picker-options="pickerOptions"
            value-format="timestamp"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
        <el-button type="danger" size="mini" style="margin-left: 10px" @click="search()">刷新</el-button>

        <el-button type="primary" size="mini" style="margin-left: 10px" @click="combine()">打包</el-button>

        <el-table
            :data="dataT"
            :key="isUpdate"
            v-loading="loading"
            highlight-current-row
            ref="multipleTable"
            size="mini"
            @select-all="select"
            @select="select"
            stripe
            height="700"
            :header-cell-style="{textAlign:'center',color:'#555555',background:'rgba(243,244,247,0.94)'}"
            style="width: 100%;margin-top: 20px">

          <el-table-column
              type="selection"
              align="center"
              width="55">
          </el-table-column>
          <el-table-column
              type="index"
              align="center"
              label="序列">
          </el-table-column>
          <!--        <el-table-column-->
          <!--            prop="exportId"-->
          <!--            label="视频标识"-->
          <!--            width="100"-->
          <!--            align="center"-->
          <!--           >-->
          <!--        </el-table-column>-->
          <el-table-column
              prop="gameName"
              label="图片"
              align="center"
              width="80"
          >
            <template slot-scope="scope">

              <el-image :src="scope.row.coverUrl" :preview-src-list="[scope.row.coverUrl]"
                        style="height: 100px"></el-image>
            </template>
          </el-table-column>
          <el-table-column
              prop="description"
              align="center"
              label="描述"

          >
          </el-table-column>
          <el-table-column
              prop="finderComponent.wording"
              align="center"

              label="绑定游戏">
          </el-table-column>
          <el-table-column
              prop="accountInfo.nickName"
              align="center"

              label="作者">
          </el-table-column>
          <el-table-column
              prop="count"
              align="center"
              label="订单选择次数">
          </el-table-column>
          <el-table-column
              prop="hotSize"
              align="center"
              label="加热次数">
          </el-table-column>
        </el-table>

      </div>
      <div v-show="this.radio3==='2'">

        <el-select
            v-model="zhanghao"
            filterable
            size="mini"
            allow-create
            clearable
            default-first-option
            @change="changeZH"
            placeholder="账号请选择">
          <el-option
              v-for="item in tableData"
              :key="item"
              :label="item.name"
              :value="item.name">

            <span style="float: left">{{ item.name }}</span>

            <span v-if="item.status===0"
                  style="margin-left:8px;float: right; color: #2bd374; font-size: 13px">在线</span>
            <span v-else style="margin-left:8px;float: right; color: #8492a6; font-size: 13px">离线</span>

            <span style="margin-left:5px;float: right; color: #7919c9; font-size: 13px">{{ item.accountBalance }}</span>
          </el-option>
        </el-select>
        <el-radio-group v-model="stats" size="mini" style="margin-left: 3px">
          <el-radio-button :label="0">全部</el-radio-button>
          <el-radio-button :label="1">待支付</el-radio-button>
          <el-radio-button :label="2">加热中</el-radio-button>
          <el-radio-button :label="3">已完成</el-radio-button>
          <el-radio-button :label="4">已结束</el-radio-button>
          <el-radio-button :label="5">审核中</el-radio-button>
          <el-radio-button :label="6">审核未通过</el-radio-button>
          <el-radio-button :label="8">退款中</el-radio-button>
          <el-radio-button :label="9">结算中</el-radio-button>
          <el-radio-button :label="10">待加热</el-radio-button>
        </el-radio-group>
        <el-date-picker
            size="mini"
            v-model="value22"
            @change="search2"
            type="daterange"
            align="right"
            unlink-panels

            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="timestamp">
        </el-date-picker>


        <el-button type="danger" size="mini" style="margin-left: 10px" @click="search2()">刷新</el-button>
        <el-button
            type="success"
            size="mini"
            style="margin-left: 10px"
            :disabled="selectedPendingPayOrderCount === 0"
            @click="showBatchPayDialog">
          批量完成支付({{ selectedPendingPayOrderCount }})
        </el-button>
        <el-button
            type="warning"
            size="mini"
            style="margin-left: 10px"
            :loading="batchQuickPayLoading"
            :disabled="selectedPendingPayOrderCount === 0"
            @click="quickPaySelectedPendingOrders">
          免验证提交({{ selectedPendingPayOrderCount }})
        </el-button>
        <el-button
            type="warning"
            size="mini"
            style="margin-left: 10px"
            :loading="batchQuickPayLoading"
            :disabled="selectedPendingPayOrderCount === 0"
            @click="openBatchPreparedQuickPays">
          多窗口支付({{ selectedPendingPayOrderCount }})
        </el-button>
        <el-button
            v-if="activeQuickPayWindowCount > 0"
            type="info"
            size="mini"
            style="margin-left: 10px"
            @click="closeAllQuickPayWindows">
          关闭支付窗口({{ activeQuickPayWindowCount }})
        </el-button>
        <el-button
            v-if="quickPayFeedback"
            type="text"
            size="mini"
            class="quick-pay-feedback">
          {{ quickPayFeedback }}
        </el-button>
        <span class="batch-pay-tip">
          已选待支付 {{ selectedPendingPayOrderCount }} / 已选订单 {{ selectedOrderRows.length }}
        </span>

        <div class="order-summary-grid">
          <div class="order-summary-card">
            <span>订单数</span>
            <strong>{{ orderDataSummary.orderCount }}</strong>
          </div>
          <div class="order-summary-card">
            <span>订单预算</span>
            <strong>{{ orderDataSummary.orderBudget }}</strong>
          </div>
          <div class="order-summary-card">
            <span>订单账面消耗</span>
            <strong>{{ orderDataSummary.bookCost }}</strong>
          </div>
          <div class="order-summary-card order-summary-progress">
            <span>消耗进度</span>
            <strong>{{ orderDataSummary.progressText }}</strong>
            <el-progress :percentage="orderDataSummary.progressPercent" :show-text="false" :stroke-width="8"></el-progress>
          </div>
          <div class="order-summary-card">
            <span>广告变现金额</span>
            <strong>{{ orderDataSummary.adAmount }}</strong>
          </div>
          <div class="order-summary-card">
            <span>付费金额</span>
            <strong>{{ orderDataSummary.payAmount }}</strong>
          </div>
        </div>


        <el-table
            :data="tableData2"
            border
            :header-cell-style="{background:'#f8f8f9',textAlign:'center',color:'#515A6E','padding':'5px'}"
            class="table-1"
            size="mini"
            stripe
            ref="tableData1"
            @select="select2"
            @selection-change="handleOrderSelectionChange"
            highlight-current-row
            height="calc(77vh - 96px)"
            v-loading="loading2"
            :summary-method="getOrderTableSummaries"
            show-summary
        >

          <el-table-column
              prop="cDate"
              label="操作"
              align="center"
              width="190"
              fixed

          >

            <template slot-scope="scope">
              <div class="order-action-cell">
                <el-button size="mini" type="primary" plain @click="dbclick(scope.row)">复用配置</el-button>
                <el-button
                    v-if="isCancelableOrder(scope.row)"
                    size="mini"
                    type="danger"
                    plain
                    @click="del(scope.row)">取消</el-button>
                <el-button
                    v-if="isPendingPayOrder(scope.row)"
                    size="mini"
                    type="success"
                    :loading="isQuickPayLoading(scope.row)"
                    @click="quickPayOrder(scope.row)">免验证</el-button>
                <el-tag
                    v-if="isQuickPayReady(scope.row)"
                    size="mini"
                    type="success"
                    effect="plain">免验就绪</el-tag>
                <el-button
                    v-if="isQuickPayReady(scope.row)"
                    size="mini"
                    type="warning"
                    plain
                    @click="openPreparedQuickPay(scope.row)">打开支付</el-button>

                <el-popover
                    placement="right"
                    v-if="isPendingPayOrder(scope.row)"
                    width="260"
                    trigger="click"
                    popper-class="pay-qr-popover">
                  <div class="pay-qr-panel">
                    <img
                        class="pay-qr-code"
                        :src="buildQrImageUrl(buildPaymentUrl(scope.row), 220)"
                        alt="微信扫码支付">
                    <div class="pay-qr-title">微信扫码支付</div>
                  </div>
                  <el-button slot="reference" size="mini" type="primary" plain icon="el-icon-zoom-in">支付码</el-button>
                </el-popover>
              </div>
            </template>

          </el-table-column>

          <el-table-column
              type="selection"
              align="center"
              fixed
              width="60">
          </el-table-column>

          <el-table-column
              type="index"
              label="订单序号"
              align="center"
              width="90">
          </el-table-column>

          <el-table-column
              align="center"
              label="订单开始消耗时间"
              width="170"
          >
            <template slot-scope="scope">
              {{ formatOrderTime(getOrderStartConsumeTime(scope.row)) }}
            </template>
          </el-table-column>


          <el-table-column
              align="center"
              label="订单号"
              width="170"
              show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div class="order-id-text">{{ displayCell(getOrderPromotionId(scope.row)) }}</div>
            </template>
          </el-table-column>

          <el-table-column
              align="center"
              label="状态"
              width="100"
              show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-tag size="mini" :type="getOrderStatusTagType(scope.row)" effect="plain">
                {{ getOrderStatusText(scope.row) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="游戏"
              min-width="130"
              show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ displayCell(getOrderGameName(scope.row)) }}
            </template>
          </el-table-column>

          <el-table-column
              align="center"
              label="封面"
              width="90"
          >
            <template slot-scope="scope">
              <el-image
                  v-if="getOrderCoverUrl(scope.row)"
                  :src="getOrderCoverUrl(scope.row)"
                  class="order-cover"
                  fit="cover"
                  :preview-src-list="[getOrderCoverUrl(scope.row)]"></el-image>
              <span v-else>-</span>
            </template>

          </el-table-column>
          <el-table-column
              label="名称"
              align="center"
              min-width="140"
              show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ displayCell(getOrderTargetName(scope.row)) }}
            </template>
          </el-table-column>
          <el-table-column
              label="订单预算"
              align="center"
              width="110"

          >
            <template slot-scope="scope">
              <div class="amount-blue">{{ formatAmount(getOrderBudget(scope.row)) }}</div>
            </template>
          </el-table-column>
          <el-table-column
              label="订单消耗"
              sortable
              width="110"
              align="center"

          >
            <template slot-scope="scope">
              <div class="amount-red">{{ formatAmount(getOrderSpend(scope.row)) }}</div>

            </template>

          </el-table-column>
          <el-table-column
              label="消耗进度"
              align="center"
              width="150"
          >
            <template slot-scope="scope">
              <div class="order-progress-cell">
                <el-progress
                    :percentage="getOrderSpendProgress(scope.row)"
                    :stroke-width="10"
                    :format="formatOrderProgressText"></el-progress>
              </div>

            </template>

          </el-table-column>

          <el-table-column
              label="roi出价"
              sortable
              width="100"
              align="center"

          >
            <template slot-scope="scope">
              {{ formatRatio(getOrderRoiBid(scope.row)) }}
            </template>

          </el-table-column>
          <el-table-column
              label="广告变现roi"
              align="center"
              width="120"
          >
            <template slot-scope="scope">
              {{ formatRatio(getOrderAdRoi(scope.row)) }}
            </template>
          </el-table-column>
          <el-table-column
              label="广告变现金额"
              align="center"
              width="120"

          >
            <template slot-scope="scope">
              {{ formatAmount(getOrderAdAmount(scope.row)) }}
            </template>
          </el-table-column>
          <el-table-column
              label="赔付券"
              align="center"
              width="100"
          >
            <template slot-scope="scope">
              {{ formatAmount(getOrderVoucherAmount(scope.row)) }}
            </template>
          </el-table-column>
          <el-table-column
              label="平均千次展示费用"
              align="center"
              width="140"
          >
            <template slot-scope="scope">
              {{ formatAmount(getOrderCpm(scope.row)) }}
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="付费内容"
          >
            <el-table-column label="付费roi出价" align="center" width="120">
              <template slot-scope="scope">
                {{ formatRatio(getOrderPayRoiBid(scope.row)) }}
              </template>
            </el-table-column>
            <el-table-column label="数据归因周期" align="center" width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ displayCell(getOrderDataAttributionCycle(scope.row)) }}
              </template>
            </el-table-column>
            <el-table-column label="付费出价" align="center" width="100">
              <template slot-scope="scope">
                {{ formatAmount(getOrderPayBid(scope.row)) }}
              </template>
            </el-table-column>
            <el-table-column label="付费金额" align="center" width="110">
              <template slot-scope="scope">
                {{ formatAmount(getOrderPayAmount(scope.row)) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
              align="center"
              label="广告内容"
          >
            <el-table-column label="广告变现成本" align="center" width="120">
              <template slot-scope="scope">
                {{ formatAmount(getOrderAdCost(scope.row)) }}
              </template>
            </el-table-column>
            <el-table-column label="广告变现人数" align="center" width="120">
              <template slot-scope="scope">
                {{ formatCount(getOrderAdUsers(scope.row)) }}
              </template>
            </el-table-column>
            <el-table-column label="预估广告变现人数" align="center" width="140">
              <template slot-scope="scope">
                {{ formatCount(getOrderEstimatedAdUsers(scope.row)) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="付费人数" align="center" width="100">
            <template slot-scope="scope">
              {{ formatCount(getOrderPayUsers(scope.row)) }}
            </template>
          </el-table-column>
          <el-table-column label="组件点击pv/uv" align="center" width="130">
            <template slot-scope="scope">
              {{ getOrderComponentClickPvUv(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column label="点击成本" align="center" width="100">
            <template slot-scope="scope">
              {{ formatAmount(getOrderClickCost(scope.row)) }}
            </template>
          </el-table-column>
          <el-table-column label="浏览量" align="center" width="100">
            <template slot-scope="scope">
              {{ formatCount(getOrderPageView(scope.row)) }}
            </template>
          </el-table-column>


        </el-table>

        <el-dialog
            title="批量完成支付"
            :visible.sync="batchPayDialogVisible"
            width="860px"
            append-to-body
            class="batch-pay-dialog">
          <div class="batch-pay-toolbar">
            <span class="batch-pay-summary">
              当前待支付订单：{{ selectedPendingPayOrderCount }} 个。点击“批量打开支付页”后，仍需在微信支付页逐个确认。
            </span>
            <div>
              <el-button size="mini" icon="el-icon-document-copy" :disabled="selectedPendingPayOrderCount === 0" @click="copyBatchPaymentUrls">
                复制全部链接
              </el-button>
              <el-button type="primary" size="mini" icon="el-icon-position" :disabled="selectedPendingPayOrderCount === 0" @click="openBatchPaymentPages">
                批量打开支付页
              </el-button>
              <el-button type="warning" size="mini" icon="el-icon-check" :loading="batchQuickPayLoading" :disabled="selectedPendingPayOrderCount === 0" @click="quickPaySelectedPendingOrders">
                批量免验证提交
              </el-button>
            </div>
          </div>
          <el-table
              :data="selectedPendingPayOrders"
              border
              size="mini"
              height="520"
              empty-text="请选择待支付订单">
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column prop="orderInfo.promotionId" label="订单号" min-width="170" align="center"></el-table-column>
            <el-table-column prop="orderInfo.estimatedWecoinAmount" label="预算" width="90" align="center"></el-table-column>
            <el-table-column prop="orderInfo.targetUserInfo.nickName" label="名称" min-width="120" align="center"></el-table-column>
            <el-table-column label="支付二维码" width="120" align="center">
              <template slot-scope="scope">
                <img
                    class="batch-pay-qr"
                    :src="buildQrImageUrl(buildPaymentUrl(scope.row), 92)"
                    alt="支付二维码">
              </template>
            </el-table-column>
            <el-table-column label="支付链接" min-width="220" align="center">
              <template slot-scope="scope">
                <span class="batch-pay-link">{{ buildPaymentUrl(scope.row) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="230" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="openPaymentPage(scope.row)">打开</el-button>
                <el-button size="mini" @click="copyPaymentUrl(scope.row)">复制</el-button>
                <el-button size="mini" type="success" :loading="isQuickPayLoading(scope.row)" @click="quickPayOrder(scope.row)">免验证</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-dialog>

        <el-drawer
            title="CPS加热余额"
            :visible.sync="cpsGoldDrawerVisible"
            size="760px"
            append-to-body
            class="cps-gold-drawer">
          <div class="cps-gold-toolbar">
            <div class="cps-gold-summary">
              <span>已筛选 CPS加热 {{ cpsGoldRows.length }} 条</span>
              <span>可用合计 {{ cpsGoldTotal }}</span>
            </div>
            <div class="cps-gold-actions">
              <el-input
                  v-model="cpsGoldKeyword"
                  size="mini"
                  clearable
                  prefix-icon="el-icon-search"
                  class="cps-gold-search"
                  placeholder="搜索名称/公司/ID">
              </el-input>
              <el-button type="primary" size="mini" icon="el-icon-refresh" :loading="cpsGoldLoading" @click="fetchCpsGoldList">
                刷新
              </el-button>
            </div>
          </div>
          <el-table
              :data="filteredCpsGoldRows"
              border
              size="mini"
              height="calc(100vh - 190px)"
              v-loading="cpsGoldLoading"
              empty-text="暂无 CPS加热 数据">
            <el-table-column prop="id" label="ID" width="90" align="center"></el-table-column>
            <el-table-column prop="name" label="名称" min-width="160" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="canUse" label="可用" width="100" align="center" sortable></el-table-column>
            <el-table-column prop="expirationDate" label="到期时间" width="120" align="center"></el-table-column>
            <el-table-column prop="update" label="更新日期" width="110" align="center"></el-table-column>
            <el-table-column prop="platform" label="平台" width="100" align="center"></el-table-column>
            <el-table-column prop="co" label="公司" min-width="120" align="center" show-overflow-tooltip></el-table-column>
          </el-table>
        </el-drawer>
      </div>
    </div>

  </div>


</template>
<script>

const MOBILE_PAY_EXPORT_KEY = 'n_ChQIAhIQ069AoCSv824bRiBCnf5zIxLyAQIE97dBBAEAAAAAAGAFLG7PCcUAAAAOpnltbLcz9gKNyK89dVj046M5lOx3u%2FM1iPOL8EL%2FjPBumHYlTBqbGdlGJDqp67kk%2B6YOs7SC1lme8FeqkKWIp0F3%2BuN5e%2BmZmVdkvP64NSlk8q%2BBTWb8eZh4lLOF8n5TyOi9JtM3V%2Fsoj390bw3pm0p8Nhx6LmCVqIwRhPzURBD0Pq8TzGr9I59iZLEiSXl34OuugrB%2FVA%2BOsRfxoNFsnm9KkoxG6XMfQydVg0QyR32eoMOuW0SdJDzQxhchQTNprTn4wCpIf%2BDd7jfRJFw%2FXN5rasy%2BZ7H2qRA8'
const MOBILE_PAY_PASS_TICKET = 'mkYT1tSASyHrOO0N%2Bau7jqdSsw1cX0GaTE4YMQ2hHO0Uw81HMntYVHhm2IrTybm0kmG0BaxyqrkRLEgqtIGpBw%3D%3D'
const WECHAT_WEBEAN_PAY_SDK_URL = 'https://res.wx.qq.com/t/wx_fed/finder/promote/web-promotion/res/js/index.publishDYBPgOwv.js'
const WEBEAN_CONSUME_PAGE_URL = 'https://webeans.my-qcloud.com/sdk/#/consume/qrcode'
const ORDER_CONFIG_COLLAPSED_KEY = 'jiare_order_config_collapsed'

function getTodayDateRange() {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const start = today.getTime()
  return [start, start]
}

function parseSavedDateRange(value) {
  if (!value) {
    return null
  }

  let dates = value
  if (typeof value === 'string') {
    try {
      dates = JSON.parse(value)
    } catch (error) {
      dates = value.split(',')
    }
  }

  if (!Array.isArray(dates) || dates.length !== 2) {
    return null
  }

  const start = Number(dates[0])
  const end = Number(dates[1])
  if (!Number.isFinite(start) || !Number.isFinite(end)) {
    return null
  }

  return [start, end]
}

export default {
  name: 'VideoBoostAutoOrder',
  computed: {
    isAttributionMetricSelected() {
      return [27, 28].includes(this.param.feedPromotionOrderInfo.promotionTarget);
    },
    advertRoiValue() {
      return this.attributionPeriod === '1' ? 27 : 28;
    },
    advertRoiText() {
      return '广告变现ROI';
    },
    orderConfigSummary() {
      const orderInfo = this.param.feedPromotionOrderInfo || {}
      const suggest = orderInfo.suggest || {}
      const targetMap = {
        3: '组件点击',
        13: '付费人数',
        16: '虚拟支付',
        17: '广告变现',
        21: '付费ROI',
        27: '广告变现ROI',
        28: '广告变现ROI'
      }
      const promotionTarget = targetMap[Number(orderInfo.promotionTarget)] || '目标未设'
      const promotionType = Number(orderInfo.promotionType) === 1 ? '智能加热' : '定向加热'
      const durationHour = Number(orderInfo.duration || 0) ? (Number(orderInfo.duration) / 3600) + '小时' : '时长未设'
      const amount = orderInfo.estimatedWecoinAmount || '预算未设'
      const bid = this.price || '未设'
      const billingMethod = Number(orderInfo.billingMethod) === 1 ? '微信豆' : '现金'
      const relax = suggest.enableSearchRelaxTargeting === false ? '搜索放宽关闭' : '搜索放宽开启'
      return promotionTarget + ' / ' + promotionType + ' / 预算 ' + amount + ' / 扣费 ' + billingMethod + ' / 出价 ' + bid + ' / ' + durationHour + ' / ' + relax
    },
    orderDataSummary() {
      const rows = Array.isArray(this.tableData2) ? this.tableData2 : []
      let orderBudget = 0
      let bookCost = 0
      let adAmount = 0
      let payAmount = 0

      rows.forEach(row => {
        orderBudget += this.numberValue(this.getOrderBudget(row)) || 0
        bookCost += this.numberValue(this.getOrderSpend(row)) || 0
        adAmount += this.numberValue(this.getOrderAdAmount(row)) || 0
        payAmount += this.numberValue(this.getOrderPayAmount(row)) || 0
      })

      const progress = orderBudget > 0 ? bookCost / orderBudget * 100 : 0
      const progressPercent = Math.max(0, Math.min(100, Number(progress.toFixed(1))))
      return {
        orderCount: rows.length,
        orderBudget: this.formatAmount(orderBudget),
        bookCost: this.formatAmount(bookCost),
        progressText: this.formatNumber(progress, 1) + '%',
        progressPercent: progressPercent,
        adAmount: this.formatAmount(adAmount),
        payAmount: this.formatAmount(payAmount)
      }
    },

    selectedPendingPayOrders() {
      return this.selectedOrderRows.filter(row => this.isPendingPayOrder(row))
    },
    selectedPendingPayOrderCount() {
      return this.selectedPendingPayOrders.length
    },
    quickPayReadyOrders() {
      return (this.tableData2 || []).filter(row => this.isQuickPayReady(row))
    },
    quickPayReadyOrderCount() {
      return this.quickPayReadyOrders.length
    },
    batchQuickPayReadyOrders() {
      return (this.selectedOrderRows || []).filter(row => this.isQuickPayReady(row))
    },
    batchQuickPayReadyOrderCount() {
      return this.batchQuickPayReadyOrders.length
    },
    cpsGoldRows() {
      return (this.cpsGoldList || []).filter(item => String(item.platform || '').trim() === 'CPS加热')
    },
    filteredCpsGoldRows() {
      const keyword = String(this.cpsGoldKeyword || '').trim().toLowerCase()
      if (!keyword) {
        return this.cpsGoldRows
      }
      return this.cpsGoldRows.filter(item => {
        return [item.id, item.name, item.co]
            .some(value => String(value || '').toLowerCase().includes(keyword))
      })
    },
    cpsGoldTotal() {
      const total = this.cpsGoldRows.reduce((sum, item) => sum + Number(item.canUse || 0), 0)
      return Number(total.toFixed(2))
    },
    activeQuickPayWindowCount() {
      const payWindows = []
      Object.values(this.quickPayWindowMap || {}).forEach(payWindow => {
        if (payWindow && !payWindow.closed && payWindows.indexOf(payWindow) === -1) {
          payWindows.push(payWindow)
        }
      })
      if (this.quickPaySingleWindow && !this.quickPaySingleWindow.closed && payWindows.indexOf(this.quickPaySingleWindow) === -1) {
        payWindows.push(this.quickPaySingleWindow)
      }
      return payWindows.length
    }
  },
  data() {
    const todayDateRange = getTodayDateRange()
    return {
      groupData: [],
      flag: '0',
      zhObject: {},
      fNum: 1,
      corId: '',
      zhanghao: '全明星热梗',
      videoName: '小妮子游戏',
      value1: todayDateRange.slice(),
      name2: '',
      isStatus: '0',
      loading2: false,
      isMore: 0,
      table: [],
      radio3: '1',
      estimatedStartts: '',
      videoShow: true,
      stats: 0,
      loading: false,
      price: '',
      attributionPeriod: '',
      orderConfigCollapsed: localStorage.getItem(ORDER_CONFIG_COLLAPSED_KEY) !== 'false',
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      param: {
        "sequence": "1000058" + (new Date().getTime()),
        "materialExportIds": [
          "export/UzFfAgtgekIEAQAAAAAAZUc5xZ2ubAAAAAstQy6ubaLX4KHWvLEZgBPE3qMEaF9qFryKzNPgMIt64FyG4mfht6NftPdxk8OA"
        ],
        "feedPromotionOrderInfo": {
          "promotionTarget": 17,//13:付费人数(  //17：广告变现  //16:虚拟支付  //13：不限)  //组件点击:9  //ROI：21
          "promotionType": 2,
          "estimatedWecoinAmount": "30000",  //下单金额
          "billingMethod": 0, //扣费资金类型 0:现金 1:微信豆
          "suggest": {
            "gender": [],  //gender性别要求0:不限  1:男  2:女
            "ageRange": [   //年龄要求  1、18-24岁  2:25-29岁  3://30-39岁   4://40-49岁  5：//50岁以上
              1,
              2,
              3,
              4
            ],
            "cityIds": [],//城市
            "interestTagV3": [],//兴趣
            "gameCategories": [],//
            "roomInfo": {
              "roomId": []
            },
            "similarUsernameList": [],
            //自定义出价
            "deviceTypes": [], //设备 1 ://ios  2:/安卓
            "gameRegisters": [    //0未注册,1已流失:2.已注册
              0
            ],
            "enableSearchRelaxTargeting": true
          },
          "duration": "43200",//加热时长
          "pricingMethod": 1,//
          "dynamicAudit": false,

          "quota": "300000",  //总金额
          "internalInfo": {
            "isInternal": false
          }
        },
        "voucherIds": [],
        "deviceInfo": {
          "deviceTypeId": 3
        },
        "multiplyVoucherIds": [],
        "baseReq": {
          "featureFlag": 26
        }
      }, tableData2: [], value22: todayDateRange.slice(),
      tableDataYuZhi: [],
      tableData: [
        {
          gameName: '',
          titleContent: '',
          filePath: '',
          descContent: '',
          cookieName: '',

          phoneId: '',
          wechatId: '',
          compId: '',

        }
      ], dataT: [], selectionArray: [],
      selectedOrderRows: [],
      batchPayDialogVisible: false,
      quickPayLoadingMap: {},
      quickPayReadyMap: {},
      quickPayWindowMap: {},
      quickPaySingleWindow: null,
      quickPayQueue: [],
      quickPayQueueIndex: 0,
      quickPayQueueRunning: false,
      quickPayQueueTimer: null,
      quickPayQueuePolling: false,
      quickPayQueueErrorCount: 0,
      quickPayFeedback: '',
      batchQuickPayLoading: false,
      weBeanPaySdk: null,
      orderRefreshTimer: null,
      orderSearchRequestId: 0,
      cpsGoldDrawerVisible: false,
      cpsGoldLoading: false,
      cpsGoldList: [],
      cpsGoldKeyword: '',
      rowIndex: undefined,
      columnIndex: undefined,
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', getTodayDateRange());
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  }, mounted() {

    if (localStorage.getItem("cc") != null) {


      this.price = localStorage.getItem("cc")
    }


    if (localStorage.getItem("cj") != null) {


      this.param.feedPromotionOrderInfo.estimatedWecoinAmount = localStorage.getItem("cj")

    }

    this.zhanghao = localStorage.getItem("zhanghao")

    this.videoName = localStorage.getItem("video")

    this.value1 = parseSavedDateRange(localStorage.getItem("date")) || getTodayDateRange()
    this.value22 = getTodayDateRange()

    console.log(localStorage.getItem("date"))

    this.search3()

  }, beforeDestroy() {
    this.stopQuickPayQueue(false, {skipRefresh: true, silent: true})
    this.clearScheduledOrderRefresh()
  }, filters: {
    dateFilter(timestamp) {
      const date = new Date(timestamp); // 根据时间戳创建Date对象
      const year = date.getFullYear(); // 获取年份
      const month = date.getMonth() + 1; // 获取月份，需要加1
      const day = date.getDate(); // 获取日期
      const hour = date.getHours(); // 获取小时
      const minute = date.getMinutes(); // 获取分钟
      const second = date.getSeconds(); // 获取秒数

      const formattedDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`;

      return formattedDate
    }
  }, updated() {

    this.$nextTick(() => {
      this.$refs['multipleTable'].doLayout();
    })
  },
  methods: {
    ensureDateRanges() {
      this.value1 = parseSavedDateRange(this.value1) || getTodayDateRange()
      this.value22 = parseSavedDateRange(this.value22) || getTodayDateRange()
    },
    clearScheduledOrderRefresh() {
      if (this.orderRefreshTimer) {
        clearTimeout(this.orderRefreshTimer)
        this.orderRefreshTimer = null
      }
    },
    normalizeCookieAccounts(accounts) {
      if (!Array.isArray(accounts)) {
        return []
      }
      return accounts.map(account => {
        const item = Object.assign({}, account)
        item.corproateAccountId = item.corproateAccountId || item.corporateAccountId || item.corproate_account_id || item.corporate_account_id || ''
        return item
      })
    },
    getCorporateAccountId(account) {
      return account
          ? account.corproateAccountId || account.corporateAccountId || account.corproate_account_id || account.corporate_account_id || ''
          : ''
    },
    scheduleOrderRefresh(delay) {
      this.clearScheduledOrderRefresh()
      this.orderRefreshTimer = setTimeout(() => {
        this.orderRefreshTimer = null
        this.search2()
      }, delay)
    },
    toggleOrderConfigCollapsed() {
      this.orderConfigCollapsed = !this.orderConfigCollapsed
      localStorage.setItem(ORDER_CONFIG_COLLAPSED_KEY, this.orderConfigCollapsed ? 'true' : 'false')
    },
    openCpsGoldDrawer() {
      this.cpsGoldDrawerVisible = true
      if (!this.cpsGoldList.length) {
        this.fetchCpsGoldList()
      }
    },
    fetchCpsGoldList() {
      this.cpsGoldLoading = true
      return this.$axios
          .get('/adGold/all')
          .then(response => {
            const body = response.data || {}
            let list = []
            if (Array.isArray(body)) {
              list = body
            } else if (Array.isArray(body.data)) {
              list = body.data
            } else if (Array.isArray(body.value)) {
              list = body.value
            } else if (Array.isArray(body.rows)) {
              list = body.rows
            }
            this.cpsGoldList = list
          })
          .catch(error => {
            console.error('CPS加热余额查询失败', error)
            this.$message.error('CPS加热余额查询失败，请稍后重试')
          })
          .finally(() => {
            this.cpsGoldLoading = false
          })
    },
    handleAttributionChange() {
      const oldValue = this.attributionPeriod === '1' ? 28 : 27;
      if (this.param.feedPromotionOrderInfo.promotionTarget === oldValue) {
        this.param.feedPromotionOrderInfo.promotionTarget = this.advertRoiValue;
      }
    },


    updateT() {

      console.log("更新订单数量=========")

      var that = this

      for (var i = 0; i < that.dataT.length; i++) {

        that.dataT[i].count = 0

        that.groupData.forEach(function (e) {

          e.forEach(function (f) {

            if (that.dataT[i].exportId === f.exportId) {

              that.dataT[i].count++

            }

          })


        })

      }

      console.log(that.dataT)
      this.$nextTick(() => {
        this.$refs['multipleTable'].doLayout();
      })
      this.isUpdate = !this.isUpdate
    },
    delGroup2(index) {

      this.groupData.splice(index, 1)
      this.updateT()

    },
    delGroup(index, index2) {


      this.groupData[index].splice(index2, 1)

      this.updateT()

      this.$nextTick(() => {
        this.$refs['multipleTable'].doLayout();
      })
    },
    ensureSearchRelaxTargeting(data = this.param) {
      if (!data.feedPromotionOrderInfo) {
        this.$set(data, 'feedPromotionOrderInfo', {})
      }
      if (!data.feedPromotionOrderInfo.suggest) {
        this.$set(data.feedPromotionOrderInfo, 'suggest', {})
      }
      if (data.feedPromotionOrderInfo.suggest.enableSearchRelaxTargeting === undefined || data.feedPromotionOrderInfo.suggest.enableSearchRelaxTargeting === null) {
        this.$set(data.feedPromotionOrderInfo.suggest, 'enableSearchRelaxTargeting', true)
      }
    },
    ensureBillingMethod(data = this.param) {
      if (!data.feedPromotionOrderInfo) {
        this.$set(data, 'feedPromotionOrderInfo', {})
      }
      const billingMethod = Number(data.feedPromotionOrderInfo.billingMethod)
      if ([0, 1].includes(billingMethod)) {
        data.feedPromotionOrderInfo.billingMethod = billingMethod
      } else {
        this.$set(data.feedPromotionOrderInfo, 'billingMethod', 0)
      }
    },
    hasDisplayValue(value) {
      return value !== undefined
          && value !== null
          && value !== ''
          && String(value).toLowerCase() !== 'null'
          && String(value).toLowerCase() !== 'undefined'
    },
    displayCell(value) {
      return this.hasDisplayValue(value) ? value : '-'
    },
    pathValue(source, path) {
      if (!source || !path) {
        return undefined
      }
      const segments = String(path).split('.')
      let current = source
      for (let i = 0; i < segments.length; i++) {
        if (current === undefined || current === null) {
          return undefined
        }
        current = current[segments[i]]
      }
      return current
    },
    firstOrderValue(row, paths) {
      for (let i = 0; i < paths.length; i++) {
        const value = this.pathValue(row, paths[i])
        if (this.hasDisplayValue(value)) {
          return value
        }
      }
      return undefined
    },
    numberValue(value) {
      if (!this.hasDisplayValue(value)) {
        return null
      }
      if (typeof value === 'number') {
        return Number.isFinite(value) ? value : null
      }
      const normalized = String(value).replace(/,/g, '').trim()
      if (!normalized) {
        return null
      }
      const number = Number(normalized)
      return Number.isFinite(number) ? number : null
    },
    formatNumber(value, digits) {
      const number = this.numberValue(value)
      if (number === null) {
        return this.displayCell(value)
      }
      const fixedDigits = digits === undefined ? 2 : digits
      return number.toLocaleString('zh-CN', {
        minimumFractionDigits: fixedDigits,
        maximumFractionDigits: fixedDigits
      })
    },
    formatAmount(value) {
      return this.formatNumber(value, 2)
    },
    formatCount(value) {
      return this.formatNumber(value, 0)
    },
    normalizeRoiValue(value) {
      const number = this.numberValue(value)
      if (number === null) {
        return null
      }
      return Math.abs(number) > 10 ? number / 100 : number
    },
    formatRatio(value) {
      const number = this.normalizeRoiValue(value)
      return number === null ? '-' : this.formatNumber(number, 2)
    },
    scaledOrderValue(row, paths, divisor) {
      const value = this.firstOrderValue(row, paths)
      const number = this.numberValue(value)
      if (number === null) {
        return null
      }
      return divisor ? number / divisor : number
    },
    getOrderStartConsumeTime(row) {
      return this.firstOrderValue(row, [
        'orderInfo.startConsumeTs',
        'orderInfo.consumeStartTs',
        'orderInfo.promotionStartTs',
        'orderInfo.startTs',
        'orderInfo.estimatedStartts',
        'estimatedStartts',
        'orderInfo.createTs',
        'date'
      ])
    },
    formatOrderTime(value) {
      if (!this.hasDisplayValue(value)) {
        return '-'
      }
      const text = String(value)
      if (text.indexOf('-') !== -1 || text.indexOf('/') !== -1) {
        return text.replace(/\.0$/, '')
      }
      const number = this.numberValue(value)
      if (number === null || number <= 0) {
        return this.displayCell(value)
      }
      const millis = number < 1000000000000 ? number * 1000 : number
      const date = new Date(millis)
      if (Number.isNaN(date.getTime())) {
        return this.displayCell(value)
      }
      const pad = n => String(n).padStart(2, '0')
      return date.getFullYear() + '-'
          + pad(date.getMonth() + 1) + '-'
          + pad(date.getDate()) + ' '
          + pad(date.getHours()) + ':'
          + pad(date.getMinutes()) + ':'
          + pad(date.getSeconds())
    },
    getOrderStatusValue(row) {
      return this.numberValue(this.firstOrderValue(row, ['orderInfo.status', 'status']))
    },
    getOrderStatusText(row) {
      const status = this.getOrderStatusValue(row)
      const statusMap = {
        1: '待支付',
        2: '加热中',
        4: '已结束',
        5: '审核中',
        6: '审核未通过',
        9: '已完成'
      }
      if (statusMap[status]) {
        return statusMap[status]
      }
      return this.displayCell(this.firstOrderValue(row, ['orderInfo.statusText', 'statusText', 'orderInfo.status']))
    },
    getOrderStatusTagType(row) {
      const status = this.getOrderStatusValue(row)
      if (status === 2) {
        return 'success'
      }
      if (status === 1 || status === 5) {
        return 'warning'
      }
      if (status === 6) {
        return 'danger'
      }
      return 'info'
    },
    getOrderGameName(row) {
      return this.firstOrderValue(row, [
        'finderObject.finderComponent.wording',
        'finderObject.finderComponent.gameName',
        'finderObject.gameName',
        'orderInfo.gameName',
        'gameName'
      ])
    },
    getOrderCoverUrl(row) {
      return this.firstOrderValue(row, [
        'finderObject.coverUrl',
        'finderObject.url',
        'orderInfo.coverUrl',
        'orderInfo.targetUserInfo.headImgUrl',
        'coverUrl'
      ])
    },
    getOrderTargetName(row) {
      return this.firstOrderValue(row, [
        'orderInfo.targetUserInfo.nickName',
        'finderObject.nickname',
        'finderObject.nickName',
        'finderObject.objectDesc',
        'name'
      ])
    },
    getOrderBudget(row) {
      const value = this.firstOrderValue(row, [
        'orderBudget',
        'budget',
        'estimatedBudget'
      ])
      if (this.hasDisplayValue(value)) {
        return value
      }
      return this.scaledOrderValue(row, [
        'orderInfo.estimatedWecoinAmount',
        'orderInfo.feedPromotionOrderInfo.estimatedWecoinAmount',
        'estimatedWecoinAmount'
      ], 10)
    },
    getOrderSpend(row) {
      const orderCost = this.scaledOrderValue(row, [
        'orderInfo.cost',
        'orderInfo.consumeWecoinAmount',
        'orderInfo.consumedWecoinAmount'
      ], 100)
      if (orderCost !== null) {
        return orderCost
      }
      return this.scaledOrderValue(row, [
        'indicator.cost',
        'indicator.orderCost',
        'cost'
      ], 100)
    },
    getOrderSpendProgress(row) {
      const budget = this.numberValue(this.getOrderBudget(row))
      const spend = this.numberValue(this.getOrderSpend(row))
      if (!budget || spend === null) {
        return 0
      }
      return Math.max(0, Math.min(100, Number((spend / budget * 100).toFixed(1))))
    },
    formatOrderProgressText(percentage) {
      return this.formatNumber(percentage, 1) + '%'
    },
    getOrderTableSummaries(param) {
      const columns = param && Array.isArray(param.columns) ? param.columns : []
      const summary = this.orderDataSummary
      return columns.map((column, index) => {
        if (index === 0) {
          return '汇总'
        }
        switch (column.label) {
          case '订单序号':
            return summary.orderCount + ' 单'
          case '订单预算':
            return summary.orderBudget
          case '订单消耗':
          case '订单账面消耗':
            return summary.bookCost
          case '消耗进度':
            return summary.progressText
          case '广告变现金额':
            return summary.adAmount
          case '付费金额':
            return summary.payAmount
          default:
            return ''
        }
      })
    },
    getOrderRoiBid(row) {
      const x100Value = this.firstOrderValue(row, [
        'orderInfo.suggest.roiBidX100',
        'orderInfo.feedPromotionOrderInfo.suggest.roiBidX100',
        'suggest.roiBidX100'
      ])
      if (this.hasDisplayValue(x100Value)) {
        return this.scaledOrderValue({value: x100Value}, ['value'], 100)
      }
      return this.firstOrderValue(row, [
        'orderInfo.suggest.roiBid',
        'orderInfo.feedPromotionOrderInfo.suggest.roiBid',
        'suggest.roiBid'
      ])
    },
    getOrderPayRoiBid(row) {
      return this.getOrderRoiBid(row)
    },
    getOrderPayBid(row) {
      return this.scaledOrderValue(row, [
        'orderInfo.suggest.wecoinBid',
        'orderInfo.feedPromotionOrderInfo.suggest.wecoinBid',
        'suggest.wecoinBid'
      ], 1000)
    },
    getOrderAdAmount(row) {
      return this.scaledOrderValue(row, [
        'indicator.feedGameAdspayPrice',
        'indicator.feedGameAdsPayPrice',
        'indicator.feedGameAdPayPrice',
        'indicator.adMonetizationAmount',
        'indicator.adMonetizationPrice',
        'orderInfo.adMonetizationAmount'
      ], 100)
    },
    getOrderAdRoi(row) {
      const value = this.firstOrderValue(row, [
        'indicator.feedGameAdspayRoi',
        'indicator.feedGameAdsPayRoi',
        'indicator.feedGameAdRoi',
        'indicator.adMonetizationRoi',
        'indicator.adRoi',
        'orderInfo.adMonetizationRoi'
      ])
      if (this.hasDisplayValue(value)) {
        return value
      }
      const spend = this.numberValue(this.getOrderSpend(row))
      const adAmount = this.numberValue(this.getOrderAdAmount(row))
      if (!spend || adAmount === null) {
        return null
      }
      return adAmount / spend
    },
    getOrderVoucherAmount(row) {
      return this.scaledOrderValue(row, [
        'orderInfo.paymentInfo.indemnifyVoucherAmountInCents',
        'orderInfo.paymentInfo.voucherAmountInCents',
        'paymentInfo.indemnifyVoucherAmountInCents'
      ], 1000)
    },
    getOrderCpm(row) {
      return this.firstOrderValue(row, [
        'indicator.averageEcpm',
        'indicator.avgEcpm',
        'indicator.ecpm',
        'indicator.cpm',
        'indicator.feedCpm',
        'indicator.feedGameCpm'
      ])
    },
    getOrderDataAttributionCycle(row) {
      return this.firstOrderValue(row, [
        'orderInfo.dataAttributionCycle',
        'dataAttributionCycle',
        'orderInfo.feedPromotionOrderInfo.dataAttributionCycle'
      ])
    },
    getOrderPayAmount(row) {
      return this.scaledOrderValue(row, [
        'indicator.feedGamePropspayPrice',
        'indicator.feedGamePropsPayPrice',
        'indicator.feedComponentpayPrice',
        'indicator.payAmount',
        'indicator.payPrice'
      ], 100)
    },
    getOrderAdUsers(row) {
      return this.firstOrderValue(row, [
        'indicator.feedMinigameAdsexposeUv',
        'indicator.feedMinigameAdsExposeUv',
        'indicator.feedGameAdspayUv',
        'indicator.adMonetizationUv',
        'indicator.adUsers'
      ])
    },
    getOrderEstimatedAdUsers(row) {
      return this.firstOrderValue(row, [
        'indicator.estimatedFeedMinigameAdsexposeUv',
        'indicator.predictFeedMinigameAdsexposeUv',
        'indicator.estimatedAdMonetizationUv',
        'indicator.predictAdUsers',
        'orderInfo.estimatedExposure',
        'orderInfo.estimatedAdMonetizationUv'
      ])
    },
    getOrderAdCost(row) {
      const value = this.firstOrderValue(row, [
        'indicator.feedGameAdspayCost',
        'indicator.feedGameAdsPayCost',
        'indicator.adMonetizationCost',
        'indicator.adCost'
      ])
      if (this.hasDisplayValue(value)) {
        return value
      }
      const spend = this.numberValue(this.getOrderSpend(row))
      const users = this.numberValue(this.getOrderAdUsers(row))
      if (!spend || !users) {
        return null
      }
      return spend / users
    },
    getOrderPayUsers(row) {
      return this.firstOrderValue(row, [
        'indicator.feedGamePropspayUv',
        'indicator.feedGamePropsPayUv',
        'indicator.feedComponentpayUv',
        'indicator.payUv',
        'indicator.payUsers'
      ])
    },
    getOrderComponentClickPvUv(row) {
      const pv = this.firstOrderValue(row, [
        'indicator.feedComponentClickPv',
        'indicator.componentClickPv',
        'indicator.feedComponentclickPv',
        'indicator.clickPv'
      ])
      const uv = this.firstOrderValue(row, [
        'indicator.feedComponentClickUv',
        'indicator.componentClickUv',
        'indicator.feedComponentclickUv',
        'indicator.clickUv'
      ])
      if (!this.hasDisplayValue(pv) && !this.hasDisplayValue(uv)) {
        return '-'
      }
      return this.formatCount(pv) + ' / ' + this.formatCount(uv)
    },
    getOrderClickCost(row) {
      const value = this.firstOrderValue(row, [
        'indicator.feedComponentClickCost',
        'indicator.componentClickCost',
        'indicator.clickCost',
        'indicator.cpc'
      ])
      if (this.hasDisplayValue(value)) {
        return value
      }
      const spend = this.numberValue(this.getOrderSpend(row))
      const uv = this.numberValue(this.firstOrderValue(row, [
        'indicator.feedComponentClickUv',
        'indicator.componentClickUv',
        'indicator.feedComponentclickUv',
        'indicator.clickUv'
      ]))
      if (!spend || !uv) {
        return null
      }
      return spend / uv
    },
    getOrderPageView(row) {
      return this.firstOrderValue(row, [
        'indicator.exposureCount',
        'indicator.feedExposePv',
        'indicator.exposePv',
        'indicator.viewPv',
        'indicator.pageView',
        'indicator.pageViews',
        'indicator.pv',
        'finderObject.readCount'
      ])
    },
    submitAll() {

      var data = this.param
      this.ensureSearchRelaxTargeting(data)
      this.ensureBillingMethod(data)
      if (this.isAttributionMetricSelected) {
        this.param.feedPromotionOrderInfo.suggest.roiBidX100 = Math.round(this.param.feedPromotionOrderInfo.suggest.roiBid * 100);
      }

      if (this.estimatedStartts != '' & this.estimatedStartts.toString().length > 5) {

        data.estimatedStartts = this.estimatedStartts.toString().substring(0, 10)
      }

      data.feedPromotionOrderInfo.suggest.wecoinBid = this.price * 100 + ''

      if (data.feedPromotionOrderInfo.promotionTarget === 21) {

        data.feedPromotionOrderInfo.suggest.roiBidX100 = this.price * 100


      }
      data.feedPromotionOrderInfo.quota = data.feedPromotionOrderInfo.estimatedWecoinAmount * 10

      var that = this

      this.groupData.forEach(function (e) {

        data.materialExportIds = []

        data.sequence = "1000058" + (new Date().getTime())//序列

        e.forEach(function (f) {

          data.materialExportIds.push(f.exportId)

        })

        var url = "";

        that.$axios
            .post(url + "/jiare/jiare?zhanghao=" + that.zhanghao + '&flag=' + that.flag, data).then(successResponse => {

          that.$notify({
            title: '提交成功，请去支付',
            message: successResponse.data.msg,
            type: 'success'
          });
        })

      })

      this.groupData = []

      this.updateT()
    },
    combine() {

      var a = []

      var that = this

      this.selectionArray.forEach(function (e) {
        a.push(e)

      })
      if (a.length > 0) {
        this.groupData.push(a)
        this.$notify({
          title: '打包成功',
          message: "太厉害了",
          type: 'success'
        });
      } else {

        this.$notify({
          title: '空空如也',
          message: "快去选视频",
          type: 'info'
        });
      }

      that.updateT()

      this.selectionArray = []

      this.$refs.multipleTable.clearSelection();


    },


    changeZH(val) {

      this.videoName = this.val

      var that = this

      this.tableData.forEach(function (e) {

        if (e.name === val) {

          that.corId = that.getCorporateAccountId(e)

        }


      })


    },
    del(row, colum, event) {
      var url = "";

      var data = {"promotionId": row.orderInfo.promotionId, "baseReq": {"featureFlag": 26}}

      this.$axios
          .post(url + "/jiare/cancelFeedPromotion?zhanghao=" + this.zhanghao, data).then(successResponse => {

        this.$notify({
          title: '取消订单成功',
          message: successResponse.data.msg,
          type: 'success'
        });
      })

    },
    isPendingPayOrder(row) {
      return !!(row && row.orderInfo && row.orderInfo.status === 1 && row.orderInfo.promotionId)
    },
    isCancelableOrder(row) {
      const status = row && row.orderInfo ? row.orderInfo.status : null
      return !!(row && row.orderInfo && row.orderInfo.promotionId && [1, 2, 5, 6].includes(status))
    },
    buildPaymentUrl(row) {
      const orderInfo = row && row.orderInfo ? row.orderInfo : {}
      const promotionId = encodeURIComponent(orderInfo.promotionId || '')
      const corproateId = encodeURIComponent(this.corId || '')
      return 'https://channels.weixin.qq.com/promote/pages/mobile_pay?promotionId=' + promotionId
          + '&type=feed&userType=3&corproateId=' + corproateId
          + '&exportkey=' + MOBILE_PAY_EXPORT_KEY
          + '&pass_ticket=' + MOBILE_PAY_PASS_TICKET
          + '&wx_header=0'
    },
    buildQrImageUrl(text, size) {
      const width = Number(size || 220)
      return 'https://api.qrserver.com/v1/create-qr-code/?size=' + width + 'x' + width
          + '&data=' + encodeURIComponent(text || '')
    },
    buildOfficialOrderDetailUrl(row) {
      const promotionId = encodeURIComponent(this.getOrderPromotionId(row) || '')
      return 'https://channels.weixin.qq.com/promote/pages/platform/short-video/detail?promotionId=' + promotionId
          + '&from=OrderList'
    },
    openOfficialOrderDetail(row) {
      if (!this.getOrderPromotionId(row)) {
        this.$message.warning('缺少订单号')
        return
      }
      const targetWindow = window.open(this.buildOfficialOrderDetailUrl(row), '_blank')
      if (!targetWindow) {
        this.copyText(this.buildOfficialOrderDetailUrl(row), '官方订单页链接已复制')
        this.$message.warning('浏览器可能拦截了弹窗，已复制官方订单页链接')
      }
    },
    canUseWeBeanIframe() {
      return window.location.hostname === 'webeans.my-qcloud.com'
    },
    buildWeBeanConsumeUrl(pcSdkInfo, isQuickPay) {
      const payInfo = String(pcSdkInfo || '').replace(/^\?/, '')
      if (!payInfo) {
        return ''
      }

      const params = [payInfo]
      if (isQuickPay && !/(^|&)secretPay=/.test(payInfo)) {
        params.push('secretPay=1')
      }
      if (!/(^|&)theme=/.test(payInfo)) {
        params.push('theme=light')
      }
      if (!/(^|&)brand_color=/.test(payInfo)) {
        params.push('brand_color=%23fa9d3b')
      }
      return WEBEAN_CONSUME_PAGE_URL + '?' + params.join('&')
    },
    openWeBeanConsumePage(row, pcSdkInfo, isQuickPay, preparedWindow) {
      const consumeUrl = this.buildWeBeanConsumeUrl(pcSdkInfo, isQuickPay)
      if (!consumeUrl) {
        this.$message.warning('缺少微信豆支付参数')
        return false
      }

      const targetWindow = preparedWindow || window.open(consumeUrl, '_blank')
      if (!targetWindow) {
        this.copyText(consumeUrl, '微信豆支付链接已复制')
        this.$message.warning('浏览器可能拦截了弹窗，已复制微信豆支付链接')
        return false
      }

      if (preparedWindow) {
        preparedWindow.location.href = consumeUrl
      }
      this.$message.success('已打开微信豆支付窗口，完成后订单列表会自动刷新')
      this.scheduleOrderRefresh(5000)
      return true
    },
    markQuickPayReady(row, pcSdkInfo) {
      const promotionId = this.getOrderPromotionId(row)
      const consumeUrl = this.buildWeBeanConsumeUrl(pcSdkInfo, true)
      if (!promotionId || !consumeUrl) {
        return false
      }
      this.$set(this.quickPayReadyMap, promotionId, {
        url: consumeUrl,
        readyAt: Date.now()
      })
      return true
    },
    getQuickPayReady(row) {
      const promotionId = this.getOrderPromotionId(row)
      return promotionId ? this.quickPayReadyMap[promotionId] : null
    },
    isQuickPayReady(row) {
      const readyInfo = this.getQuickPayReady(row)
      return !!(readyInfo && readyInfo.url && this.isPendingPayOrder(row))
    },
    openQuickPayUrlInSingleWindow(consumeUrl, options) {
      options = options || {}
      const allowCreate = options.allowCreate !== false
      let targetWindow = this.quickPaySingleWindow

      if (!targetWindow || targetWindow.closed) {
        if (!allowCreate) {
          return null
        }
        targetWindow = window.open('', 'jiare_quick_pay_window')
      }

      if (!targetWindow) {
        return null
      }

      this.quickPaySingleWindow = targetWindow
      targetWindow.location.href = consumeUrl
      try {
        targetWindow.focus()
      } catch (e) {
        console.warn(e)
      }
      return targetWindow
    },
    openQuickPayUrlInNewWindow(consumeUrl) {
      const targetWindow = window.open(consumeUrl, '_blank')
      if (!targetWindow) {
        return null
      }
      try {
        targetWindow.focus()
      } catch (e) {
        console.warn(e)
      }
      return targetWindow
    },
    openPreparedPayWindow() {
      const targetWindow = window.open('about:blank', '_blank')
      if (!targetWindow) {
        return null
      }
      try {
        targetWindow.document.title = '支付准备中'
        targetWindow.document.body.innerHTML = '<div style="font-family:Arial,sans-serif;padding:24px;color:#333">支付参数准备中，请稍候...</div>'
        targetWindow.focus()
      } catch (e) {
        console.warn(e)
      }
      return targetWindow
    },
    redirectPreparedPayWindow(targetWindow, consumeUrl) {
      if (!targetWindow || targetWindow.closed || !consumeUrl) {
        return false
      }
      targetWindow.location.href = consumeUrl
      try {
        targetWindow.focus()
      } catch (e) {
        console.warn(e)
      }
      return true
    },
    openPreparedQuickPay(row, options) {
      options = options || {}
      const shouldNotify = options.silent !== true
      const readyInfo = this.getQuickPayReady(row)
      if (!readyInfo || !readyInfo.url) {
        if (shouldNotify) {
          this.$message.warning('请先点击免验证准备支付参数')
        }
        return false
      }
      const targetWindow = this.openQuickPayUrlInNewWindow(readyInfo.url)
      if (!targetWindow) {
        this.copyText(readyInfo.url, '微信豆支付链接已复制')
        if (shouldNotify) {
          this.$message.warning('浏览器可能拦截了弹窗，已复制微信豆支付链接')
        }
        return false
      }
      const promotionId = this.getOrderPromotionId(row)
      if (promotionId) {
        this.$set(this.quickPayWindowMap, promotionId, targetWindow)
      }
      if (shouldNotify) {
        this.$message.success('已打开微信豆支付页，完成后请刷新订单状态')
        this.scheduleOrderRefresh(5000)
      }
      return true
    },
    async openBatchPreparedQuickPays() {
      const orders = this.selectedPendingPayOrders
      if (!orders.length) {
        this.$message.warning('请先勾选待支付订单')
        return
      }

      this.stopQuickPayQueue(false, {skipRefresh: true, silent: true})

      const targets = []
      const seenPromotionIds = []
      orders.forEach(row => {
        const promotionId = this.getOrderPromotionId(row)
        if (!promotionId || seenPromotionIds.indexOf(promotionId) !== -1) {
          return
        }
        seenPromotionIds.push(promotionId)
        targets.push({
          row,
          promotionId,
          targetWindow: this.openPreparedPayWindow()
        })
      })

      if (!targets.length) {
        this.$message.warning('已选订单缺少订单号，无法打开支付')
        return
      }

      this.batchQuickPayLoading = true
      const openedPromotionIds = []
      const blockedUrls = []
      const failedPromotionIds = []

      try {
        for (let i = 0; i < targets.length; i++) {
          const target = targets[i]
          let readyInfo = this.getQuickPayReady(target.row)

          if (!readyInfo || !readyInfo.url) {
            const ready = await this.quickPayOrder(target.row, {silent: true})
            readyInfo = ready ? this.getQuickPayReady(target.row) : null
          }

          if (!readyInfo || !readyInfo.url) {
            failedPromotionIds.push(target.promotionId)
            if (target.targetWindow && !target.targetWindow.closed) {
              target.targetWindow.close()
            }
            continue
          }

          if (!this.redirectPreparedPayWindow(target.targetWindow, readyInfo.url)) {
            blockedUrls.push(readyInfo.url)
            continue
          }

          openedPromotionIds.push(target.promotionId)
          this.$set(this.quickPayWindowMap, target.promotionId, target.targetWindow)
        }
      } finally {
        this.batchQuickPayLoading = false
      }

      if (blockedUrls.length) {
        this.copyText(blockedUrls.join('\n'), '未打开的支付链接已复制')
      }

      if (openedPromotionIds.length) {
        this.quickPayFeedback = '已打开支付窗口 ' + openedPromotionIds.length + ' 个'
        if (failedPromotionIds.length || blockedUrls.length) {
          this.$message.warning(this.quickPayFeedback + '，失败 ' + failedPromotionIds.length + ' 个，拦截 ' + blockedUrls.length + ' 个')
        } else {
          this.$message.success(this.quickPayFeedback)
        }
      } else {
        this.quickPayFeedback = ''
        this.$message.warning(blockedUrls.length ? '支付窗口全部被浏览器拦截，链接已复制' : '所选订单均未能准备支付参数')
      }
    },
    getCurrentQuickPayQueueId() {
      return this.quickPayQueue[this.quickPayQueueIndex] || ''
    },
    getQuickPayRowByPromotionId(promotionId) {
      return (this.tableData2 || []).find(row => this.getOrderPromotionId(row) === promotionId)
    },
    openCurrentQuickPayInSingleWindow(allowCreate) {
      const promotionId = this.getCurrentQuickPayQueueId()
      const readyInfo = promotionId ? this.quickPayReadyMap[promotionId] : null
      if (!promotionId || !readyInfo || !readyInfo.url) {
        this.advanceQuickPayQueue()
        return false
      }

      const targetWindow = this.openQuickPayUrlInSingleWindow(readyInfo.url, {allowCreate})
      if (!targetWindow) {
        this.copyText(readyInfo.url, '微信豆支付链接已复制')
        this.$message.warning('支付窗口已关闭或被浏览器拦截，已复制当前支付链接')
        this.stopQuickPayQueue(false, {skipRefresh: true})
        return false
      }

      this.$set(this.quickPayWindowMap, promotionId, targetWindow)
      this.quickPayFeedback = '单窗口支付 ' + (this.quickPayQueueIndex + 1) + '/' + this.quickPayQueue.length
      return true
    },
    clearQuickPayQueueTimer() {
      if (this.quickPayQueueTimer) {
        clearTimeout(this.quickPayQueueTimer)
        this.quickPayQueueTimer = null
      }
    },
    startQuickPayQueuePoll(delay) {
      this.clearQuickPayQueueTimer()
      if (!this.quickPayQueueRunning) {
        return
      }
      this.quickPayQueueTimer = setTimeout(() => {
        this.quickPayQueueTimer = null
        this.pollQuickPayQueue()
      }, delay || 5000)
    },
    async pollQuickPayQueue() {
      if (!this.quickPayQueueRunning || this.quickPayQueuePolling) {
        return
      }
      this.quickPayQueuePolling = true
      try {
        await this.refreshOrderListForQuickPay()
        if (!this.quickPayQueueRunning) {
          return
        }
        this.quickPayQueueErrorCount = 0
        const promotionId = this.getCurrentQuickPayQueueId()
        if (!promotionId || !this.isPromotionPendingById(promotionId)) {
          this.advanceQuickPayQueue()
        }
      } catch (e) {
        console.warn(e)
        this.quickPayQueueErrorCount++
        if (this.quickPayQueueErrorCount >= 3) {
          this.stopQuickPayQueue(false, {skipRefresh: true})
          this.quickPayFeedback = '订单状态刷新失败，已停止自动刷新'
          return
        }
        this.quickPayFeedback = '单窗口支付等待状态刷新'
      } finally {
        this.quickPayQueuePolling = false
        if (this.quickPayQueueRunning && !this.quickPayQueueTimer) {
          this.startQuickPayQueuePoll()
        }
      }
    },
    refreshOrderListForQuickPay() {
      this.ensureDateRanges()
      this.tableData.forEach(item => {
        if (item.name === this.zhanghao) {
          this.corId = this.getCorporateAccountId(item)
        }
      })
      return this.$axios
          .get('/data/zhibo/findAllData?stats=' + this.stats + '&start=' + this.value22[0] + '&end=' + (this.value22[1] + 86400000) + '&id=' + this.zhanghao, {})
          .then(successResponse => {
            if (successResponse.status === 200) {
              this.tableData2 = successResponse.data.data
              this.syncQuickPayReadyWithOrders()
            }
          })
    },
    isPromotionPendingById(promotionId) {
      const row = this.getQuickPayRowByPromotionId(promotionId)
      return !!(row && this.isPendingPayOrder(row))
    },
    advanceQuickPayQueueManually() {
      this.advanceQuickPayQueue()
    },
    advanceQuickPayQueue() {
      const currentPromotionId = this.getCurrentQuickPayQueueId()
      if (currentPromotionId) {
        this.$delete(this.quickPayReadyMap, currentPromotionId)
        this.$delete(this.quickPayWindowMap, currentPromotionId)
      }

      this.quickPayQueueIndex++
      if (this.quickPayQueueIndex >= this.quickPayQueue.length) {
        this.stopQuickPayQueue(true, {skipRefresh: true})
        this.quickPayFeedback = '单窗口支付已完成'
        return
      }

      this.openCurrentQuickPayInSingleWindow(false)
    },
    stopQuickPayQueue(closeWindow, options) {
      options = options || {}
      this.quickPayQueueRunning = false
      this.quickPayQueue = []
      this.quickPayQueueIndex = 0
      this.quickPayQueuePolling = false
      this.quickPayQueueErrorCount = 0
      this.clearQuickPayQueueTimer()

      if (closeWindow && this.quickPaySingleWindow && !this.quickPaySingleWindow.closed) {
        this.quickPaySingleWindow.close()
      }
      if (closeWindow || !this.quickPaySingleWindow || this.quickPaySingleWindow.closed) {
        this.quickPaySingleWindow = null
      }

      if (!options.silent) {
        this.quickPayFeedback = closeWindow ? '单窗口支付已结束' : ''
      }

      if (!options.skipRefresh) {
        this.search2()
      }
    },
    closeAllQuickPayWindows() {
      let closeCount = 0
      const singleWindow = this.quickPaySingleWindow

      this.clearQuickPayQueueTimer()
      this.quickPayQueueRunning = false
      this.quickPayQueue = []
      this.quickPayQueueIndex = 0
      this.quickPayQueuePolling = false
      this.quickPayQueueErrorCount = 0

      if (singleWindow && !singleWindow.closed) {
        singleWindow.close()
        closeCount++
      }
      this.quickPaySingleWindow = null

      Object.keys(this.quickPayWindowMap || {}).forEach(promotionId => {
        const payWindow = this.quickPayWindowMap[promotionId]
        if (payWindow && payWindow !== singleWindow && !payWindow.closed) {
          payWindow.close()
          closeCount++
        }
        this.$delete(this.quickPayWindowMap, promotionId)
      })
      this.quickPayFeedback = closeCount > 0 ? '已关闭支付窗口 ' + closeCount + ' 个' : ''
    },
    syncQuickPayReadyWithOrders() {
      const pendingIds = new Set((this.tableData2 || [])
          .filter(row => this.isPendingPayOrder(row))
          .map(row => this.getOrderPromotionId(row))
          .filter(Boolean))

      Object.keys(this.quickPayReadyMap || {}).forEach(promotionId => {
        if (!pendingIds.has(promotionId)) {
          const payWindow = this.quickPayWindowMap[promotionId]
          const shouldKeepQueueWindow = this.quickPayQueueRunning && payWindow === this.quickPaySingleWindow
          if (payWindow && !payWindow.closed && !shouldKeepQueueWindow) {
            payWindow.close()
          }
          this.$delete(this.quickPayWindowMap, promotionId)
          this.$delete(this.quickPayReadyMap, promotionId)
        }
      })
      this.stopCompletedQuickPayQueueIfNeeded(pendingIds)
    },
    stopCompletedQuickPayQueueIfNeeded(pendingIds) {
      if (!this.quickPayQueueRunning || !this.quickPayQueue.length) {
        return
      }
      const hasPendingQueuedOrder = this.quickPayQueue.some(promotionId => pendingIds.has(promotionId))
      if (!hasPendingQueuedOrder) {
        this.stopQuickPayQueue(true, {skipRefresh: true})
        this.quickPayFeedback = '单窗口支付已完成'
      }
    },
    showBatchPayDialog() {
      if (this.selectedPendingPayOrderCount === 0) {
        this.$message.warning('请先选择待支付订单')
        return
      }
      this.batchPayDialogVisible = true
    },
    openPaymentPage(row) {
      if (!this.isPendingPayOrder(row)) {
        this.$message.warning('只能打开待支付订单')
        return
      }
      const payWindow = window.open(this.buildPaymentUrl(row), '_blank')
      if (!payWindow) {
        this.copyPaymentUrl(row)
        this.$message.warning('浏览器可能拦截了弹窗，已复制支付链接')
      }
    },
    openBatchPaymentPages() {
      if (this.selectedPendingPayOrderCount === 0) {
        this.$message.warning('请先选择待支付订单')
        return
      }
      this.selectedPendingPayOrders.forEach(row => {
        window.open(this.buildPaymentUrl(row), '_blank')
      })
      this.$message.success('已尝试打开 ' + this.selectedPendingPayOrderCount + ' 个支付页，如浏览器拦截请逐个打开')
    },
    copyPaymentUrl(row) {
      if (!this.isPendingPayOrder(row)) {
        this.$message.warning('只能复制待支付订单链接')
        return
      }
      this.copyText(this.buildPaymentUrl(row), '支付链接已复制')
    },
    copyBatchPaymentUrls() {
      if (this.selectedPendingPayOrderCount === 0) {
        this.$message.warning('请先选择待支付订单')
        return
      }
      const text = this.selectedPendingPayOrders.map(row => this.buildPaymentUrl(row)).join('\n')
      this.copyText(text, '全部支付链接已复制')
    },
    getOrderPromotionId(row) {
      return this.firstOrderValue(row, [
        'orderInfo.promotionId',
        'promotionId',
        'orderInfo.orderId',
        'orderInfo.order_id',
        'orderId',
        'order_id'
      ]) || ''
    },
    isQuickPayLoading(row) {
      const promotionId = this.getOrderPromotionId(row)
      return !!(promotionId && this.quickPayLoadingMap[promotionId])
    },
    getOrderExportIds(row) {
      const ids = []
      const addId = value => {
        if (value === undefined || value === null || value === '') {
          return
        }
        if (Array.isArray(value)) {
          value.forEach(addId)
          return
        }
        ids.push(value)
      }
      const addFromArray = array => {
        if (!Array.isArray(array)) {
          return
        }
        array.forEach(item => {
          if (!item) {
            return
          }
          if (typeof item === 'string') {
            addId(item)
          } else {
            addId(item.exportId || item.materialExportId || item.materialExportIds)
          }
        })
      }
      const orderInfo = row && row.orderInfo ? row.orderInfo : {}
      addId(orderInfo.materialExportIds)
      addId(row && row.finderObject ? row.finderObject.exportId : '')
      addFromArray(row && row.finderObjects)
      addFromArray(row && row.materialInfos)
      addFromArray(orderInfo.materialInfos)
      return Array.from(new Set(ids.filter(Boolean)))
    },
    getOrderVoucherIds(row) {
      const ids = []
      const addVoucher = item => {
        if (!item) {
          return
        }
        if (typeof item === 'string') {
          ids.push(item)
          return
        }
        ids.push(item.id || item.voucherId)
      }
      const orderInfo = row && row.orderInfo ? row.orderInfo : {}
      const voucherIds = orderInfo.voucherIds || row.voucherIds || []
      if (Array.isArray(voucherIds)) {
        voucherIds.forEach(addVoucher)
      } else {
        addVoucher(voucherIds)
      }
      return ids.filter(Boolean)
    },
    buildQuickPayPayload(row) {
      const orderInfo = row && row.orderInfo ? row.orderInfo : {}
      const estimatedWecoinAmount = Number(orderInfo.estimatedWecoinAmount || 0)
      const quota = Number(orderInfo.quota || orderInfo.promotionQuota || estimatedWecoinAmount * 10 || 0)
      return {
        promotionId: this.getOrderPromotionId(row),
        exportIds: this.getOrderExportIds(row),
        promotionQuota: quota,
        payMethod: orderInfo.billingMethod == null ? 0 : orderInfo.billingMethod,
        promotionTarget: orderInfo.promotionTarget == null ? 0 : Number(orderInfo.promotionTarget),
        voucherIds: this.getOrderVoucherIds(row),
        promotionBusiness: 1,
        pcSdkFlag: 1,
        createType: 0
      }
    },
    prepareFeedQuickPay(row) {
      const payload = this.buildQuickPayPayload(row)
      if (!payload.promotionId) {
        return Promise.reject(new Error('缺少订单号'))
      }
      return this.$axios.post('/data/zhibo/prepareFeedQuickPay?zhanghao=' + encodeURIComponent(this.zhanghao || ''), payload)
    },
    async quickPayOrder(row, options) {
      options = options || {}
      const shouldNotify = options.silent !== true

      if (!this.isPendingPayOrder(row)) {
        if (shouldNotify) {
          this.$message.warning('只能提交待支付订单')
        }
        return false
      }

      const promotionId = this.getOrderPromotionId(row)
      if (this.isQuickPayLoading(row)) {
        return false
      }

      this.$set(this.quickPayLoadingMap, promotionId, true)
      try {
        const successResponse = await this.prepareFeedQuickPay(row)
        const body = successResponse.data || {}
        if (!body.success) {
          if (shouldNotify) {
            this.$message.error(body.msg || '免验证提交准备失败')
          }
          return false
        }

        const payData = body.data || {}
        if (!payData.isQuickPay) {
          if (shouldNotify) {
            this.$message.warning('该订单当前不能免验证')
          }
          return false
        }

        if (!payData.pcSdkInfo) {
          if (shouldNotify) {
            this.$message.warning('微信未返回支付参数')
          }
          return false
        }

        if (!this.canUseWeBeanIframe()) {
          const ready = this.markQuickPayReady(row, payData.pcSdkInfo)
          if (shouldNotify) {
            this.$message.success(ready ? '免验证支付参数已准备好，请点击打开支付' : '免验证支付参数准备失败')
          }
          return ready
        }

        const consumeResult = await this.consumeWeBeanPayment(payData.pcSdkInfo, true)
        if (consumeResult === null) {
          if (shouldNotify) {
            this.$message.warning('当前页面未加载微信支付组件')
          }
          return false
        }

        if (consumeResult) {
          if (shouldNotify) {
            this.$message.success('免验证提交成功')
          }
          this.scheduleOrderRefresh(1200)
          return true
        }

        if (shouldNotify) {
          this.$message.warning('支付已取消或未完成')
        }
        return false
      } catch (error) {
        if (shouldNotify) {
          this.$message.error(error.message || '免验证提交失败')
        }
        return false
      } finally {
        this.$delete(this.quickPayLoadingMap, promotionId)
      }
    },
    async quickPaySelectedPendingOrders() {
      if (this.selectedPendingPayOrderCount === 0) {
        this.$message.warning('请先选择待支付订单')
        return
      }
      this.batchQuickPayLoading = true
      const orders = this.selectedPendingPayOrders.slice()
      let readyCount = 0

      try {
        for (let i = 0; i < orders.length; i++) {
          const ready = await this.quickPayOrder(orders[i], {silent: true})
          if (ready) {
            readyCount++
          }
        }
      } finally {
        this.batchQuickPayLoading = false
      }

      const failCount = orders.length - readyCount
      this.quickPayFeedback = '免验证就绪 ' + readyCount + ' 个，未通过 ' + failCount + ' 个'
      if (readyCount > 0) {
        this.$message.success(this.quickPayFeedback + '，可在行内点击打开支付')
      } else {
        this.$message.warning('所选订单当前都不能免验证')
      }
    },
    async getWeBeanPaySdk() {
      const candidates = [
        this.weBeanPaySdk,
        window.WeBeanPay,
        window.weBeanPay,
        window.WeBean,
        window.weBean,
        window.webean,
        window.__WEPAY_SDK__,
        window.__webeanPay
      ]

      for (let i = 0; i < candidates.length; i++) {
        const sdk = candidates[i]
        if (!sdk) {
          continue
        }
        if (typeof sdk.consume === 'function') {
          this.weBeanPaySdk = sdk
          return sdk
        }
        if (typeof sdk.init === 'function') {
          const instance = sdk.init({theme: 'light', brandColor: '#fa9d3b'})
          if (instance && typeof instance.consume === 'function') {
            this.weBeanPaySdk = instance
            return instance
          }
        }
      }

      try {
        const module = await import(/* webpackIgnore: true */ WECHAT_WEBEAN_PAY_SDK_URL)
        const sdk = module && module.i
        if (sdk && typeof sdk.init === 'function') {
          this.weBeanPaySdk = sdk.init({theme: 'light', brandColor: '#fa9d3b'})
          return this.weBeanPaySdk
        }
      } catch (error) {
        console.error('加载微信支付组件失败', error)
      }

      return null
    },
    async consumeWeBeanPayment(pcSdkInfo, isQuickPay) {
      const sdk = await this.getWeBeanPaySdk()
      if (!sdk || typeof sdk.consume !== 'function') {
        return Promise.resolve(null)
      }

      const payInfo = isQuickPay && pcSdkInfo.indexOf('secretPay=1') === -1 ? pcSdkInfo + '&secretPay=1' : pcSdkInfo
      return new Promise((resolve, reject) => {
        try {
          sdk.consume({
            pcSDKInfo: payInfo,
            onReady: () => {},
            onSuccess: () => resolve(true),
            onClose: () => resolve(false),
            onError: error => reject(new Error((error && error.errMsg) || '支付失败'))
          })
        } catch (error) {
          reject(error)
        }
      })
    },
    copyText(text, successMessage) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success(successMessage)
        }).catch(() => this.fallbackCopyText(text, successMessage))
      } else {
        this.fallbackCopyText(text, successMessage)
      }
    },
    fallbackCopyText(text, successMessage) {
      const input = document.createElement('textarea')
      input.value = text
      input.style.position = 'fixed'
      input.style.left = '-9999px'
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success(successMessage)
    },
    getCode(codeImg) {
      console.log('二维码图片');
    },

    format(row, column, cellValue) {

      const date = new Date(cellValue * 1000);

      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();

      return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds


    },
    dbclick(row, colum, event) {
      const orderInfo = row && row.orderInfo ? row.orderInfo : null
      if (!orderInfo) {
        this.$message.warning('缺少订单配置，无法复用')
        return
      }

      const target = this.param.feedPromotionOrderInfo
      const suggest = orderInfo.suggest ? JSON.parse(JSON.stringify(orderInfo.suggest)) : {}
      const wecoinBid = suggest.wecoinBid === undefined || suggest.wecoinBid === null ? '' : String(suggest.wecoinBid)

      this.price = wecoinBid.length > 2 ? wecoinBid.substring(0, wecoinBid.length - 2) : this.price
      this.$set(target, 'suggest', suggest)

      if (orderInfo.duration !== undefined && orderInfo.duration !== null) {
        target.duration = orderInfo.duration + ''
      }
      if (orderInfo.promotionTarget !== undefined && orderInfo.promotionTarget !== null) {
        target.promotionTarget = orderInfo.promotionTarget
      }
      if (orderInfo.promotionType !== undefined && orderInfo.promotionType !== null) {
        target.promotionType = orderInfo.promotionType
      }
      if (orderInfo.quota !== undefined && orderInfo.quota !== null) {
        target.quota = orderInfo.quota
      }
      if (orderInfo.estimatedWecoinAmount !== undefined && orderInfo.estimatedWecoinAmount !== null) {
        target.estimatedWecoinAmount = orderInfo.estimatedWecoinAmount
      }
      if (orderInfo.pricingMethod !== undefined && orderInfo.pricingMethod !== null) {
        target.pricingMethod = orderInfo.pricingMethod
      }
      if (orderInfo.dynamicAudit !== undefined && orderInfo.dynamicAudit !== null) {
        target.dynamicAudit = orderInfo.dynamicAudit
      }
      if (orderInfo.billingMethod !== undefined && orderInfo.billingMethod !== null) {
        target.billingMethod = Number(orderInfo.billingMethod)
      }

      this.ensureSearchRelaxTargeting()
      this.ensureBillingMethod()
      this.radio3 = '1'
      this.$message.success('已复用订单配置，请选择视频后下单')
      this.$nextTick(() => {
        const panel = document.querySelector('.order-config-panel')
        if (panel && panel.scrollIntoView) {
          panel.scrollIntoView({behavior: 'smooth', block: 'start'})
        }
      })
    },
    change() {


      if (this.radio3 === '1') {

        this.videoShow = false

      }


    },
    search3(val) {

      this.$axios
          .post('/data/zhibo/findAllCookies', {})
          .then(successResponse => {
            if (successResponse.status === 200 && successResponse.data && successResponse.data.success) {
              if (!Array.isArray(successResponse.data.data)) {
                this.tableData = []
                this.size = 0
                this.$message.warning(successResponse.data.msg || '账号接口未返回有效数据')
                return
              }

              this.tableData = this.normalizeCookieAccounts(successResponse.data.data)
              this.size = this.tableData.length

              // this.$router.push({ path:'/index',name: 'AppIndex', params: { id:successResponse.data}})

            } else {
              this.tableData = []
              this.size = 0
              this.$message.error((successResponse.data && successResponse.data.msg) || '账号列表查询失败')

            }
          })
          .catch(error => {
            this.tableData = []
            this.size = 0
            this.$message.error(error.message || '账号列表查询失败')
          })


    },
    search4(val) {

      localStorage.setItem("zhanghao", this.zhanghao)

      this.$axios
          .post('/jiare/findAllyuZhi?zhanghao=' + this.zhanghao + '&status=' + this.isStatus, {})
          .then(successResponse => {
            if (successResponse.status == 200) {

              this.tableDataYuZhi = successResponse.data.data
              this.size = successResponse.data.size
              console.log(this.tableDataYuZhi)
              // this.$router.push({ path:'/index',name: 'AppIndex', params: { id:successResponse.data}})

            } else {
              this.$router.replace({path: '/error'})
              console.log("错误")

            }
          })


    },
    search2() {

      this.clearScheduledOrderRefresh()
      this.ensureDateRanges()
      const requestId = ++this.orderSearchRequestId
      this.loading2 = true
      this.selectedOrderRows = []

      var that = this

      this.tableData.forEach(function (e) {

        if (e.name === that.zhanghao) {

          that.corId = that.getCorporateAccountId(e)

        }


      })

      return this.$axios
          .get('/data/zhibo/findAllData?stats=' + this.stats + '&start=' + this.value22[0] + '&end=' + (this.value22[1] + 86400000) + '&id=' + this.zhanghao, {})
          .then(successResponse => {
            if (requestId !== this.orderSearchRequestId) {
              return
            }
            if (successResponse.status === 200) {

              this.tableData2 = successResponse.data.data
              this.syncQuickPayReadyWithOrders()

            } else {
              this.$router.replace({path: '/error'})
              console.log("错误")

            }
          })
          .catch(error => {
            if (requestId !== this.orderSearchRequestId) {
              return
            }
            console.error('订单列表刷新失败', error)
            this.$message.error('订单列表刷新失败，请稍后重试')
          })
          .finally(() => {
            if (requestId === this.orderSearchRequestId) {
              this.loading2 = false
            }
          })


    },


    submit() {


      var data = this.param
      this.ensureSearchRelaxTargeting(data)
      this.ensureBillingMethod(data)
      if (this.isAttributionMetricSelected) {
        this.param.feedPromotionOrderInfo.suggest.roiBidX100 = Math.round(this.param.feedPromotionOrderInfo.suggest.roiBid * 100);
      }

      if (this.estimatedStartts != '' & this.estimatedStartts.toString().length > 5) {

        data.estimatedStartts = this.estimatedStartts.toString().substring(0, 10)
      }

      data.feedPromotionOrderInfo.suggest.wecoinBid = this.price * 100 + ''

      if (data.feedPromotionOrderInfo.promotionTarget === 21) {

        data.feedPromotionOrderInfo.suggest.roiBidX100 = this.price * 100


      }

      data.feedPromotionOrderInfo.quota = data.feedPromotionOrderInfo.estimatedWecoinAmount * 10


      var that = this

      var i = 0;

      if (this.isMore === 0) {

        this.selectionArray.forEach(function (e) {

              data.sequence = "1000058" + (new Date().getTime())//序列

              data.materialExportIds[0] = e.exportId

              var url = "";

              that.$axios
                  .post(url + "/jiare/jiare?zhanghao=" + that.zhanghao + '&flag=' + that.flag, data).then(successResponse => {

                that.$notify({
                  title: '提交成功，请去支付',
                  message: successResponse.data.msg,
                  type: 'success'
                });
              })

            }
        )
      } else {

        var index = 1

        var tt = 1

        var leng = 0

        data.materialExportIds = []

        this.selectionArray.forEach(function (e) {

          data.sequence = "1000058" + (new Date().getTime())//序列

          data.materialExportIds.push(e.exportId)

          var url = "";

          //到达数量,提交订单
          if (index % that.fNum === 0) {

            leng = data.materialExportIds.length

            that.$axios
                .post(url + "/jiare/jiare?zhanghao=" + that.zhanghao + '&flag=' + that.flag, data).then(successResponse => {


              that.$notify({
                title: '提交第' + tt + '单成功，本单共计视频' + leng + '个',
                message: successResponse.data.msg,
                type: 'success'
              });

              tt++
            })


            // //提交完后清空
            data.materialExportIds = []
            //


          }

          index++
        })


      }

      localStorage.setItem("cj", this.param.feedPromotionOrderInfo.estimatedWecoinAmount)
      localStorage.setItem("cc", this.price)
    },
    submitYuO() {

      var that = this

      this.selectionArray.forEach(function (e) {


        var url = "";

        const orderData = JSON.parse(e.orderData)
        that.ensureSearchRelaxTargeting(orderData)
        that.ensureBillingMethod(orderData)

        that.$axios
            .post(url + "/jiare/jiare?zhanghao=" + that.zhanghao + '&flag=' + that.flag, orderData).then(successResponse => {

          that.$notify({
            title: '提交成功，请去支付',
            message: successResponse.data.msg,
            type: 'success'
          });
        })

        that.$axios

            .post(url + "/jiare/updateYuzhi?zhanghao=" + that.zhanghao + '&id=' + e.id, {}).then(successResponse => {


        })
      })


    }
    , submitYu() {

      var data = this.param
      this.ensureSearchRelaxTargeting(data)
      this.ensureBillingMethod(data)
      if (this.isAttributionMetricSelected) {
        this.param.feedPromotionOrderInfo.suggest.roiBidX100 = Math.round(this.param.feedPromotionOrderInfo.suggest.roiBid * 100);
      }

      if (this.estimatedStartts != '' & this.estimatedStartts.toString().length > 5) {

        data.estimatedStartts = this.estimatedStartts.toString().substring(0, 10)
      }

      data.feedPromotionOrderInfo.suggest.wecoinBid = this.price * 100 + ''

      if (data.feedPromotionOrderInfo.promotionTarget === 21) {

        data.feedPromotionOrderInfo.suggest.roiBidX100 = this.price * 100


      }
      data.feedPromotionOrderInfo.quota = data.feedPromotionOrderInfo.estimatedWecoinAmount * 10
      var that = this

      var i = 0;

      this.selectionArray.forEach(function (e) {

        data.sequence = "1000058" + (new Date().getTime())//序列

        data.materialExportIds[0] = e.exportId

        data['coverUrl'] = e.coverUrl

        var url = "";

        that.$axios
            .post(url + "/jiare/saveYuzhi?zhanghao=" + that.zhanghao + '&flag=' + that.flag, data).then(successResponse => {

          that.$notify({
            title: '已加工成预制餐，请记得下单',
            message: successResponse.data.msg,
            type: 'success'
          });
        })

      })


    }

    , select(selection, row) {

      console.log(this.selectionArray.length)


      var a = []

      selection.forEach(function (e) {

        var b = {}

        b['exportId'] = e.exportId

        b['coverUrl'] = e.coverUrl

        b['hotSize'] = e.hotSize

        console.log(e)

        a.push(b)

      })

      this.selectionArray = a

      console.log(this.selectionArray)

    },

    select5(selection, row) {

      console.log(this.selectionArray.length)

      var a = []

      selection.forEach(function (e) {

        a.push(e)

      })

      this.selectionArray = a

      console.log(this.selectionArray)

    },
    handleOrderSelectionChange(selection) {
      this.selectedOrderRows = selection || []
    },
    select2(selection, row) {

      console.log(this.selectionArray.length)
      this.handleOrderSelectionChange(selection)


      var a = []

      selection.forEach(function (e) {

        var b = {}

        b['exportId'] = e.finderObject.exportId

        b['coverUrl'] = e.finderObject.coverUrl

        a.push(b)

      })

      this.selectionArray = a

      console.log(this.selectionArray)
    },
    search() {

      this.ensureDateRanges()
      localStorage.setItem("zhanghao", this.zhanghao)

      localStorage.setItem("video", this.videoName)

      localStorage.setItem("date", JSON.stringify(this.value1))


      this.loading = true

      var url = "";

      this.$axios
          .get(url + "/jiare/findVideo?zhanghao=" + this.zhanghao + "&startTime=" + (this.value1[0].toString().slice(0, 10)) + "&endTime=" + ((this.value1[1] + 86400000).toString().slice(0, 10)) + "&video=" + this.videoName, {}).then(successResponse => {
        this.dataT = successResponse.data.data
        this.loading = false

        this.updateT()
      })

      console.log(this.value1)

    }, formDate(date) {
      // 将Excel日期转换为JavaScript日期
      const jsDate = new Date((date - 25569) * 86400 * 1000);
      // 将JavaScript日期转换为指定格式：yyyy-MM-dd
      const year = jsDate.getFullYear();
      const month = String(jsDate.getMonth() + 1).padStart(2, '0');
      const day = String(jsDate.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    /** 设置行、列索引 */
    getCellIndex: function ({row, column, rowIndex, columnIndex}) {
      row.index = rowIndex;
      column.index = columnIndex;
    },
    /** 点击单元格 */
    cellClick(row, column, cell, event) {
      // console.log(row, column, cell, event);
      this.rowIndex = row.index
      this.columnIndex = column.index
    },
    /** 复制粘贴 */
    pasteInfo(e) {
      try {
        e.preventDefault(); //阻止默认粘贴事件
        e.stopPropagation(); //阻止事件冒泡

        var data = null;
        var clipboardData = e.clipboardData || window.clipboardData; // IE
        if (!clipboardData) {
          //chrome
          clipboardData = e.originalEvent.clipboardData;
        }
        data = clipboardData.getData("Text"); //复制过来的内容
        //首先对源头进行解析
        if (data && !data.includes('\r\n')) { // 单独复制文本，不是复制单个单元格
          data = data + '\r\n'
        }
        var rowStrArray = data.split("\r\n"); //拆成多行
        let rows = [];
        for (var i = 0; i < rowStrArray.length - 1; i++) {
          var row = [];
          var tdStrArray = rowStrArray[i].split("\t"); //按列拆分
          for (var k = 0; k < tdStrArray.length; k++) {
            row.push(tdStrArray[k]);
          }
          rows.push(row);
        }
        // console.log(rows,'---------rows')

        let emptyObj = { //需要复制粘贴的key值列
          gameName: undefined,
          titleContent: undefined,
          filePath: undefined,
          descContent: undefined,
          cookieName: undefined,
          phoneId: undefined,
          wechatId: undefined,
          compId: undefined

        }
        for (var j = 0; j < rows.length; j++) {
          if (this.rowIndex + j > this.tableData.length - 1) {
            break
          }
          let item = {}
          item = JSON.parse(JSON.stringify(this.tableData[this.rowIndex + j]))
          let num = 0
          let numFlag = 0 //从哪一列开始粘贴：全部列都可以粘贴(即从第0列可以粘贴)
          for (var key in emptyObj) {
            if (!rows[j][num]) {
              break
            }
            // console.log('numFlag--', numFlag, 'this.columnIndex--', this.columnIndex, 'num-', num);
            if (this.columnIndex <= numFlag) {
              // 针对不能修改的列字段做处理，可以复制粘贴的列才做赋值。根据需求加下面的if判断
              // if (key !== 'jg') {
              item[key] = rows[j][num]
              // }
              num = num + 1
            }
            numFlag = numFlag + 1
          }
          this.$set(this.tableData, this.rowIndex + j, item)
        }
      } catch (err) {
        this.$message.error('请选择粘贴位置')
      }
    },
  }
}
</script>
<style>

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.config-help-popper {
  max-width: 320px;
  line-height: 1.6;
  font-size: 12px;
}
</style>

<style scoped>
.jia-re-page {
  min-height: 100vh;
  padding: 16px 0 24px;
  background: #f4f6f8;
  color: #303133;
}

.bbb {
  box-sizing: border-box;
  width: calc(100% - 32px);
  margin: 0 auto;
  padding: 16px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 8px 24px rgba(31, 45, 61, 0.06);
}

.top-action-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ebeef5;
}

.top-action-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
}

.page-tabs {
  flex-shrink: 0;
  margin-bottom: 0;
}

.cps-gold-entry {
  margin-left: 0;
  vertical-align: top;
}

.box-card {
  margin-bottom: 12px;
  border-radius: 8px;
  border-color: #e4e7ed;
}

.submit-all-button {
  margin: 0;
  min-width: 88px;
}

.order-config-panel {
  margin: 0 0 14px;
  padding: 0 18px 16px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 10px rgba(31, 45, 61, 0.05);
}

.order-config-panel.is-collapsed {
  padding-bottom: 0;
}

.order-config-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 0;
  margin-bottom: 14px;
  border-bottom: 1px solid #ebeef5;
}

.order-config-panel.is-collapsed .order-config-header {
  min-height: 42px;
  padding: 8px 0;
  margin-bottom: 0;
  border-bottom: 0;
}

.order-config-heading {
  min-width: 0;
  flex: 1;
}

.order-config-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.order-config-title {
  color: #303133;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
}

.order-config-subtitle {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}

.order-config-panel.is-collapsed .order-config-subtitle {
  overflow: hidden;
  max-width: 980px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.order-config-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;
}

.order-config-body {
  padding-top: 0;
}

.config-section {
  padding: 12px 0;
  border-bottom: 1px dashed #e4e7ed;
}

.config-section-last {
  padding-bottom: 0;
  border-bottom: 0;
}

.config-section-title {
  padding-left: 8px;
  margin-bottom: 10px;
  border-left: 3px solid #fa9d3b;
  color: #303133;
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
}

.config-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px 16px;
  align-items: start;
}

.config-field {
  box-sizing: border-box;
  min-height: 62px;
  padding: 10px 12px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fafbfc;
}

.config-field-wide {
  grid-column: span 2;
}

.config-field-xl {
  grid-column: span 2;
}

.config-label {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
  color: #606266;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  white-space: nowrap;
}

.label-with-tip .el-icon-info {
  color: #909399;
  font-size: 14px;
}

.radio-list,
.checkbox-list {
  line-height: 26px;
}

.config-inline {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
}

.split-tip {
  color: #e6a23c;
  font-size: 12px;
}

.selected-summary {
  display: inline-block;
  margin: 2px 0 12px;
  padding: 5px 10px;
  border-radius: 4px;
  background: #ecf5ff;
  color: #2b73d2;
  font-family: "Microsoft YaHei", Arial, sans-serif;
  font-size: 13px;
  font-weight: 600;
}

.order-summary-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(132px, 1fr));
  gap: 10px;
  margin: 10px 0 0;
}

.order-summary-card {
  min-height: 58px;
  padding: 9px 12px;
  border: 1px solid #e6ebf2;
  border-left: 4px solid #409eff;
  border-radius: 6px;
  background: #fff;
  box-sizing: border-box;
}

.order-summary-card span {
  display: block;
  color: #7d8796;
  font-size: 12px;
  line-height: 18px;
}

.order-summary-card strong {
  display: block;
  margin-top: 3px;
  color: #1f2d3d;
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
}

.order-summary-progress /deep/ .el-progress {
  margin-top: 4px;
}

.table-1 {
  margin-top: 12px;
}

.order-id-text {
  color: #303133;
  font-weight: 600;
}

.amount-blue {
  color: #0b77e3;
  font-weight: 600;
}

.amount-red {
  color: #f56c6c;
  font-weight: 600;
}

.order-cover {
  width: 58px;
  height: 58px;
  display: block;
  margin: 0 auto;
  border-radius: 4px;
}

.order-progress-cell {
  min-width: 120px;
  padding: 0 6px;
}

.order-progress-cell /deep/ .el-progress__text {
  min-width: 38px;
  font-size: 12px !important;
}

.order-action-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 44px;
  padding: 4px 0;
}

.order-action-cell /deep/ .el-button {
  margin: 0;
}

.order-action-cell /deep/ .el-button--mini {
  min-width: 64px;
  padding: 7px 10px;
}

.pay-qr-panel {
  padding: 8px 0 4px;
  text-align: center;
}

.pay-qr-code {
  width: 220px;
  height: 220px;
}

.pay-qr-title {
  margin-top: 8px;
  color: #606266;
  font-size: 13px;
}

.order-config-panel /deep/ .el-radio {
  margin-right: 14px;
  line-height: 24px;
}

.order-config-panel /deep/ .el-checkbox {
  margin-right: 14px;
  line-height: 24px;
}

.order-config-panel /deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #fa9d3b;
  background: #fa9d3b;
}

.order-config-panel /deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #303133;
  font-weight: 600;
}

.order-config-panel /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.order-config-panel /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #fa9d3b;
  background-color: #fa9d3b;
}

.order-config-panel /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #303133;
  font-weight: 600;
}

.order-config-panel /deep/ .el-input-number--mini {
  width: 132px;
}

.order-config-panel /deep/ .start-time-picker.el-date-editor.el-input {
  width: 190px;
}

.order-config-panel /deep/ .split-number.el-input-number--mini {
  width: 112px;
}

.batch-pay-tip {
  margin-left: 10px;
  color: #606266;
  font-size: 12px;
}

.quick-pay-feedback {
  margin-left: 10px;
  color: #67c23a;
  font-weight: 600;
}

.batch-pay-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.batch-pay-summary {
  color: #606266;
  font-size: 13px;
}

.batch-pay-qr {
  width: 86px;
  height: 86px;
}

.batch-pay-link {
  display: block;
  overflow: hidden;
  color: #409eff;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cps-gold-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 20px 12px;
}

.cps-gold-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  color: #606266;
  font-size: 13px;
  font-weight: 600;
}

.cps-gold-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cps-gold-search {
  width: 220px;
}

.cps-gold-drawer /deep/ .el-drawer__body {
  overflow: hidden;
}

.cps-gold-drawer /deep/ .el-table {
  margin: 0 20px;
  width: calc(100% - 40px);
}


/* 改变input框背景颜色 */
/deep/ .el-input__inner {
  background-color: rgba(240, 240, 240, 0.94);

}

.order-config-panel /deep/ .el-input__inner {
  background-color: #fff;
}

@media (max-width: 1200px) {
  .config-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 900px) {
  .bbb {
    width: calc(100% - 16px);
    padding: 10px;
  }

  .top-action-bar {
    align-items: flex-start;
    flex-direction: column;
  }

  .top-action-actions {
    justify-content: flex-start;
  }

  .order-config-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .order-config-actions {
    width: 100%;
    justify-content: flex-start;
  }

  .config-field-wide,
  .config-field-xl {
    grid-column: span 1;
  }

  .config-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

</style>
